export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Base64: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Instant: { input: any; output: any; }
};

export type AcceptEbomPartAllocationSuggestionCommand = {
  id: Scalars['ID']['input'];
  milliQuantity: Scalars['Int']['input'];
};

export type AccountMutationRoot = {
  __typename?: 'AccountMutationRoot';
  adminCreateOrganization: Organization;
  adminCreateUser: User;
  adminDeleteOrganization: Scalars['ID']['output'];
  adminDeleteOrganizationPermissions: Scalars['Boolean']['output'];
  adminSetOrganizationPermissions: Array<PermissionOrganization>;
  adminSetUserPermissions: Array<PermissionUser>;
  adminUpdateOrganization: Organization;
  adminUpdateUser: User;
  agreeToTerms: Scalars['Boolean']['output'];
  deleteOrganizationPermissions: Scalars['Boolean']['output'];
  inviteUserToOrganization: Scalars['Boolean']['output'];
  setOrganizationPermissions: Array<PermissionOrganization>;
  updateOrganization: Organization;
};


export type AccountMutationRootAdminCreateOrganizationArgs = {
  command: CreateOrganization;
};


export type AccountMutationRootAdminCreateUserArgs = {
  command: CreateUser;
};


export type AccountMutationRootAdminDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type AccountMutationRootAdminDeleteOrganizationPermissionsArgs = {
  command: DeleteOrganizationPermissions;
};


export type AccountMutationRootAdminSetOrganizationPermissionsArgs = {
  command: SetOrganizationPermissions;
};


export type AccountMutationRootAdminSetUserPermissionsArgs = {
  command: SetUserPermissions;
};


export type AccountMutationRootAdminUpdateOrganizationArgs = {
  command: UpdateOrganization;
};


export type AccountMutationRootAdminUpdateUserArgs = {
  command: UpdateUser;
};


export type AccountMutationRootAgreeToTermsArgs = {
  logEntry: Scalars['String']['input'];
};


export type AccountMutationRootDeleteOrganizationPermissionsArgs = {
  command: DeleteOrganizationPermissions;
};


export type AccountMutationRootInviteUserToOrganizationArgs = {
  permissions: Array<InputMaybe<PermissionOrganization>>;
  userCommand: CreateUser;
};


export type AccountMutationRootSetOrganizationPermissionsArgs = {
  command: SetOrganizationPermissions;
};


export type AccountMutationRootUpdateOrganizationArgs = {
  command: UpdateOrganization;
};

export type AccountRoot = {
  __typename?: 'AccountRoot';
  adminOrganizationPermissions: Array<OrganizationUserPermissions>;
  adminOrganizations: Array<Organization>;
  adminSearchUsers: Array<User>;
  adminUser: User;
  adminUserPermissions: Array<PermissionUser>;
  currentOrganization: Organization;
  hasAgreedToTerms: Scalars['Boolean']['output'];
  isEmailTaken: Scalars['Boolean']['output'];
  isOrganizationSlugTaken: Scalars['Boolean']['output'];
  me?: Maybe<CurrentUserAndPermissions>;
  orgPermissionsHierarchy: Array<OrgReachablePermission>;
  organizationBySlug?: Maybe<Organization>;
  organizationPermissions: Array<PermissionOrganization>;
  organizationSearchUsers: Array<User>;
  organizationUser: User;
  organizationUsers: Array<User>;
  organizations: Array<OrganizationUserPermissions>;
};


export type AccountRootAdminOrganizationPermissionsArgs = {
  userId: Scalars['ID']['input'];
};


export type AccountRootAdminSearchUsersArgs = {
  criteria: UserSearchCriteria;
};


export type AccountRootAdminUserArgs = {
  id: Scalars['ID']['input'];
};


export type AccountRootAdminUserPermissionsArgs = {
  userId: Scalars['ID']['input'];
};


export type AccountRootIsEmailTakenArgs = {
  email: Scalars['String']['input'];
  exceptUser?: InputMaybe<Scalars['ID']['input']>;
};


export type AccountRootIsOrganizationSlugTakenArgs = {
  exceptOrganization?: InputMaybe<Scalars['ID']['input']>;
  slug: Scalars['String']['input'];
};


export type AccountRootOrganizationBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type AccountRootOrganizationPermissionsArgs = {
  userId: Scalars['ID']['input'];
};


export type AccountRootOrganizationSearchUsersArgs = {
  criteria: UserSearchCriteria;
};


export type AccountRootOrganizationUserArgs = {
  id: Scalars['ID']['input'];
};


export type AccountRootOrganizationUsersArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type AddTreeGraphNode = {
  entityId: Scalars['ID']['input'];
  node: SetTreeGraphNode;
};

export type AllocateArticleToStepCommand = {
  articleId: Scalars['ID']['input'];
  milliQuantity: Scalars['Int']['input'];
  stepId: Scalars['ID']['input'];
};

export type AllocateEbomPartToStepCommand = {
  ebomPartId: Scalars['ID']['input'];
  milliQuantity: Scalars['Int']['input'];
  stepId: Scalars['ID']['input'];
};

export type Article = IArticle & {
  __typename?: 'Article';
  articleNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issueLinks: Array<IssueLink>;
  name?: Maybe<Scalars['String']['output']>;
  released: Scalars['Boolean']['output'];
  revision: Scalars['String']['output'];
  type: ArticleType;
  unit: ArticleUnit;
};

export type ArticleAllocation = EbomPartAllocation | ManualArticleAllocation;

export type ArticleIssueLink = IssueLinkI & {
  __typename?: 'ArticleIssueLink';
  article: Article;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: Issue;
};

export type ArticleMutationRoot = {
  __typename?: 'ArticleMutationRoot';
  acceptEbomPartAllocationSuggestion: EbomPartAllocationSuggestion;
  acceptEbomPartAllocationSuggestions: Array<Maybe<Scalars['ID']['output']>>;
  allocateArticleToStep: Scalars['Boolean']['output'];
  allocateEbomPartToStep: Scalars['Boolean']['output'];
  bulkAllocateEbomPartsToStep: Scalars['Boolean']['output'];
  createArticle: Article;
  createEbomPartAllocationSuggestions: Array<EbomPartAllocationSuggestion>;
  deleteArticle: Scalars['ID']['output'];
  deleteEbom: Scalars['ID']['output'];
  loadEbomFromCsv: LoadEbomResult;
  promoteEbomPartsToArticles: Array<EbomPart>;
  rejectEbomPartAllocationSuggestion: EbomPartAllocationSuggestion;
  rejectEbomPartAllocationSuggestions: Array<Maybe<Scalars['ID']['output']>>;
  replaceEbomPartAllocations: Scalars['Boolean']['output'];
  snoozeEbomParts: Scalars['Boolean']['output'];
  unsnoozeEbomParts: Scalars['Boolean']['output'];
  updateArticle: Article;
};


export type ArticleMutationRootAcceptEbomPartAllocationSuggestionArgs = {
  command: AcceptEbomPartAllocationSuggestionCommand;
};


export type ArticleMutationRootAcceptEbomPartAllocationSuggestionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type ArticleMutationRootAllocateArticleToStepArgs = {
  command: AllocateArticleToStepCommand;
};


export type ArticleMutationRootAllocateEbomPartToStepArgs = {
  command: AllocateEbomPartToStepCommand;
};


export type ArticleMutationRootBulkAllocateEbomPartsToStepArgs = {
  command: BulkAllocateEbomPartsToStepCommand;
};


export type ArticleMutationRootCreateArticleArgs = {
  command: CreateArticle;
};


export type ArticleMutationRootCreateEbomPartAllocationSuggestionsArgs = {
  ebomId: Scalars['ID']['input'];
};


export type ArticleMutationRootDeleteArticleArgs = {
  id: Scalars['ID']['input'];
};


export type ArticleMutationRootDeleteEbomArgs = {
  id: Scalars['ID']['input'];
};


export type ArticleMutationRootLoadEbomFromCsvArgs = {
  command: LoadEbomFromCsvCommand;
};


export type ArticleMutationRootPromoteEbomPartsToArticlesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type ArticleMutationRootRejectEbomPartAllocationSuggestionArgs = {
  id: Scalars['ID']['input'];
};


export type ArticleMutationRootRejectEbomPartAllocationSuggestionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type ArticleMutationRootReplaceEbomPartAllocationsArgs = {
  command: ReplaceEbomPartAllocationsCommand;
};


export type ArticleMutationRootSnoozeEbomPartsArgs = {
  ebomPartIds: Array<Scalars['ID']['input']>;
};


export type ArticleMutationRootUnsnoozeEbomPartsArgs = {
  ebomPartIds: Array<Scalars['ID']['input']>;
};


export type ArticleMutationRootUpdateArticleArgs = {
  command: UpdateArticle;
};

export type ArticlePath = {
  __typename?: 'ArticlePath';
  articleNumbers: Array<Scalars['String']['output']>;
};

export type ArticleRoot = {
  __typename?: 'ArticleRoot';
  article: Article;
  articles: Array<Article>;
  ebom: Ebom;
  ebomPart: EbomPart;
  ebomParts: Array<EbomPart>;
  ebomsForBop: Array<Ebom>;
};


export type ArticleRootArticleArgs = {
  id: Scalars['ID']['input'];
};


export type ArticleRootArticlesArgs = {
  query: ArticleSearchQuery;
};


export type ArticleRootEbomArgs = {
  id: Scalars['ID']['input'];
};


export type ArticleRootEbomPartArgs = {
  id: Scalars['ID']['input'];
};


export type ArticleRootEbomPartsArgs = {
  query: EbomPartSearchQuery;
};


export type ArticleRootEbomsForBopArgs = {
  bopId: Scalars['ID']['input'];
};

export type ArticleSearchQuery = {
  articleNumber?: InputMaybe<Scalars['String']['input']>;
  containsString?: InputMaybe<Scalars['String']['input']>;
  revision?: InputMaybe<Scalars['String']['input']>;
};

export enum ArticleType {
  Consumable = 'CONSUMABLE',
  Part = 'PART'
}

export enum ArticleUnit {
  Gram = 'GRAM',
  Kilogram = 'KILOGRAM',
  Liter = 'LITER',
  Meter = 'METER',
  Milliliter = 'MILLILITER',
  Millimeter = 'MILLIMETER',
  Pieces = 'PIECES'
}

export type Bop = {
  __typename?: 'BOP';
  id: Scalars['ID']['output'];
  issueLinks: Array<IssueLink>;
  nodes: Array<ModuleNode>;
  productConfiguration: ProductConfiguration;
  site: Site;
  version: Scalars['Int']['output'];
  versionStatus: VersionStatus;
};

export type BopIssueLink = IssueLinkI & {
  __typename?: 'BOPIssueLink';
  bop: Bop;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: Issue;
};

export type BulkAllocateEbomPartsToStepCommand = {
  ebomPartIds: Array<Scalars['ID']['input']>;
  stepId: Scalars['ID']['input'];
};

export type Check = ConfirmCheck | NumericCheck | StringCheck;

export type CheckConfiguration = {
  __typename?: 'CheckConfiguration';
  bop: Bop;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  lowerLimit?: Maybe<Scalars['Int']['output']>;
  module: Module;
  order: Scalars['Int']['output'];
  pinnedId: Scalars['ID']['output'];
  step: Step;
  type: CheckType;
  unreleasedChecks: Array<Check>;
  upperLimit?: Maybe<Scalars['Int']['output']>;
};

export type CheckI = {
  configuration: CheckConfiguration;
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  poNumber: Scalars['String']['output'];
  released: Scalars['Boolean']['output'];
  reportingUser: User;
  serialNumber: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type CheckSearchQuery = {
  poNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export enum CheckType {
  Confirmation = 'CONFIRMATION',
  Numeric = 'NUMERIC',
  String = 'STRING'
}

export type ConfirmCheck = CheckI & {
  __typename?: 'ConfirmCheck';
  configuration: CheckConfiguration;
  confirmed: Scalars['Boolean']['output'];
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  poNumber: Scalars['String']['output'];
  released: Scalars['Boolean']['output'];
  reportingUser: User;
  serialNumber: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type CreateArticle = {
  articleNumber: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  revision: Scalars['String']['input'];
  type: ArticleType;
  unit: ArticleUnit;
};

export type CreateCheckConfigurationCommand = {
  bopId: Scalars['ID']['input'];
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isRequired: Scalars['Boolean']['input'];
  lowerLimit?: InputMaybe<Scalars['Int']['input']>;
  moduleId: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
  stepId: Scalars['ID']['input'];
  type: CheckType;
  upperLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateImageStepUpload = {
  caption?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  stepId: Scalars['ID']['input'];
  uploadId: Scalars['ID']['input'];
};

export type CreateIssue = {
  assignedToUserIds: Array<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  uploadIds: Array<Scalars['ID']['input']>;
};

export type CreateIssueComment = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
  uploadIds: Array<Scalars['ID']['input']>;
};

export type CreateModule = {
  abbreviation: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
};

export type CreateMultipartUpload = {
  contentType: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateOrganization = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type CreateProduct = {
  abbreviation: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imageUploadId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateProductConfiguration = {
  abbreviation: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  forProductId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  imageUploadId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateProductionBatchCommand = {
  assignedUserId?: InputMaybe<Scalars['ID']['input']>;
  bopId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  moduleId: Scalars['ID']['input'];
  poNumber: Scalars['String']['input'];
  serialNumbers: Array<Scalars['ID']['input']>;
};

export type CreateSite = {
  abbreviation: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateStep = {
  durationInSeconds: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  instructionText?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
  stepTypeId: Scalars['ID']['input'];
  toolIds: Array<Scalars['ID']['input']>;
};

export type CreateStepInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  milliQuantity: Scalars['Int']['input'];
  moduleId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
  stepOutputId: Scalars['ID']['input'];
};

export type CreateStepOutput = {
  articleId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  milliQuantity: Scalars['Int']['input'];
  moduleId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};

export type CreateStepProposalsFromMedia = {
  fromUploadId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  inLanguage: Language;
};

export type CreateStepProposalsFromPdf = {
  firstPage: Scalars['Int']['input'];
  fromUploadId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  language: Language;
  lastPage: Scalars['Int']['input'];
};

export type CreateStepType = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTool = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imageUploadIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  siteId: Scalars['ID']['input'];
};

export type CreateUser = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  lastname: Scalars['String']['input'];
  needsPassword: Scalars['Boolean']['input'];
};

export type CreateVideoStepUpload = {
  caption?: InputMaybe<Scalars['String']['input']>;
  fragmentEndInMillis?: InputMaybe<Scalars['Int']['input']>;
  fragmentLoop?: InputMaybe<Scalars['Boolean']['input']>;
  fragmentStartInMillis?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  stepId: Scalars['ID']['input'];
  uploadId: Scalars['ID']['input'];
};

export type CsvConfig = {
  articleNumberColumn: Scalars['String']['input'];
  ebomName: Scalars['String']['input'];
  encoding: CsvEncoding;
  nameColumn?: InputMaybe<Scalars['String']['input']>;
  parentArticleNumberColumn: Scalars['String']['input'];
  quantityColumn: Scalars['String']['input'];
  revisionColumn: Scalars['String']['input'];
  unitColumn?: InputMaybe<Scalars['String']['input']>;
};

export enum CsvEncoding {
  Iso_8859_1 = 'ISO_8859_1',
  UsAscii = 'US_ASCII',
  Utf_8 = 'UTF_8'
}

export type CsvExtension = {
  __typename?: 'CsvExtension';
  columnNames: Array<Scalars['String']['output']>;
};

export type CurrentUserAndPermissions = {
  __typename?: 'CurrentUserAndPermissions';
  orgPermissions: Array<PermissionOrganization>;
  organization?: Maybe<Organization>;
  user: User;
  userPermissions: Array<PermissionUser>;
};

export type DagNode = {
  id: Scalars['ID']['output'];
  parentIds: Array<Scalars['ID']['output']>;
};

export type DeleteCheckCommand = {
  checkConfigurationId: Scalars['ID']['input'];
  poNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type DeleteOrganizationPermissions = {
  orgId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type DraftBopByDuplicating = {
  bopId: Scalars['ID']['input'];
  productConfigId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
};

export type DuplicateModule = {
  fromBOPId: Scalars['ID']['input'];
  fromModuleId: Scalars['ID']['input'];
  toBOPId: Scalars['ID']['input'];
};

export type DuplicateStep = {
  fromBOPId: Scalars['ID']['input'];
  fromModuleId: Scalars['ID']['input'];
  fromStepId: Scalars['ID']['input'];
  toBOPId: Scalars['ID']['input'];
  toModuleId: Scalars['ID']['input'];
};

export type Ebom = {
  __typename?: 'Ebom';
  ebomParts: Array<EbomPart>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  sourceType: EbomSourceType;
};

/**
 * A part in the EBOM in a specific assembly (which could be the root assembly).
 * The EBOM can consist of multiple EbomParts, referencing the same Part but in a diferent assembly in the EBOM.
 */
export type EbomPart = IArticle & {
  __typename?: 'EbomPart';
  article?: Maybe<Article>;
  articleNumber: Scalars['String']['output'];
  articlePath: ArticlePath;
  ebomId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** How many times the Part was present in the assembly in 1/1000 unit */
  milliQuantity: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  revision: Scalars['String']['output'];
  snoozeStatus: EbomPartSnoozeStatus;
  stepAllocationSuggestions: Array<EbomPartAllocationSuggestion>;
  stepAllocations: Array<EbomPartAllocation>;
  unit: ArticleUnit;
};

export type EbomPartAllocation = IArticleAllocation & {
  __typename?: 'EbomPartAllocation';
  article: Article;
  ebomPart: EbomPart;
  id: Scalars['ID']['output'];
  milliQuantity: Scalars['Int']['output'];
  step: Step;
};

export type EbomPartAllocationSuggestion = {
  __typename?: 'EbomPartAllocationSuggestion';
  decision: EbomPartAllocationSuggestionDecision;
  ebomPart: EbomPart;
  id: Scalars['ID']['output'];
  milliQuantity: Scalars['Int']['output'];
  source: EbomPartAllocationSuggestionSource;
  step: Step;
};

export enum EbomPartAllocationSuggestionDecision {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Undecided = 'UNDECIDED'
}

export enum EbomPartAllocationSuggestionSource {
  HistoricAllocation = 'HISTORIC_ALLOCATION'
}

export type EbomPartSearchQuery = {
  ebomId: Scalars['ID']['input'];
  searchString: Scalars['String']['input'];
};

export enum EbomPartSnoozeStatus {
  None = 'NONE',
  PathArticle = 'PATH_ARTICLE',
  PathArticleRevision = 'PATH_ARTICLE_REVISION',
  PathArticleRevisionQuantity = 'PATH_ARTICLE_REVISION_QUANTITY'
}

export enum EbomSourceType {
  Csv = 'CSV'
}

export type GenericExtension = {
  __typename?: 'GenericExtension';
  uploadId: Scalars['ID']['output'];
};

export enum GraphEntityType {
  BillOfProcess = 'BILL_OF_PROCESS',
  Module = 'MODULE',
  Step = 'STEP'
}

export type IArticle = {
  articleNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  revision: Scalars['String']['output'];
  unit: ArticleUnit;
};

export type IArticleAllocation = {
  article: Article;
  id: Scalars['ID']['output'];
  milliQuantity: Scalars['Int']['output'];
  step: Step;
};

export type IStepUpload = {
  id: Scalars['ID']['output'];
  upload: Upload;
};

export type ImageExtension = {
  __typename?: 'ImageExtension';
  url: Scalars['String']['output'];
};


export type ImageExtensionUrlArgs = {
  options: ImageOptions;
};

export type ImageOptions = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageStepUpload = IStepUpload & {
  __typename?: 'ImageStepUpload';
  caption?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  upload: Upload;
};

export type InviteUserToOrganization = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  lastname: Scalars['String']['input'];
  needsPassword: Scalars['Boolean']['input'];
  permissions: Array<PermissionOrganization>;
};

export type Issue = {
  __typename?: 'Issue';
  assignedToUserIds: Array<Scalars['ID']['output']>;
  assignedToUsers: Array<User>;
  comments: Array<IssueComment>;
  createdAt: Scalars['Instant']['output'];
  createdByUser: User;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  links: Array<IssueLink>;
  name: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['Instant']['output']>;
  updatedAt: Scalars['Instant']['output'];
  uploadIds: Array<Scalars['ID']['output']>;
  uploads: Array<Upload>;
};

export type IssueComment = {
  __typename?: 'IssueComment';
  createdAt: Scalars['Instant']['output'];
  createdByUser: User;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  resolvedAt?: Maybe<Scalars['Instant']['output']>;
  updatedAt: Scalars['Instant']['output'];
  uploadIds: Array<Scalars['ID']['output']>;
  uploads: Array<Upload>;
};

export type IssueLink = ArticleIssueLink | BopIssueLink | ModuleIssueLink | SerialNumberIssueLink | StepIssueLink;

export type IssueLinkI = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: Issue;
};

export type IssueMutationRoot = {
  __typename?: 'IssueMutationRoot';
  createIssue: Issue;
  createIssueComment: IssueComment;
  deleteIssue: Scalars['ID']['output'];
  deleteIssueComment: Scalars['ID']['output'];
  deleteIssueLink: Scalars['ID']['output'];
  linkIssueToArticle: ArticleIssueLink;
  linkIssueToBOP: BopIssueLink;
  linkIssueToModule: ModuleIssueLink;
  linkIssueToSerialNumber: SerialNumberIssueLink;
  linkIssueToSerialNumbers: Array<SerialNumberIssueLink>;
  linkIssueToStep: StepIssueLink;
  setIssueCommentResolved: IssueComment;
  updateIssue: Issue;
  updateIssueComment: IssueComment;
  updateIssueLink: IssueLink;
};


export type IssueMutationRootCreateIssueArgs = {
  command: CreateIssue;
};


export type IssueMutationRootCreateIssueCommentArgs = {
  command: CreateIssueComment;
};


export type IssueMutationRootDeleteIssueArgs = {
  id: Scalars['ID']['input'];
};


export type IssueMutationRootDeleteIssueCommentArgs = {
  id: Scalars['ID']['input'];
};


export type IssueMutationRootDeleteIssueLinkArgs = {
  id: Scalars['ID']['input'];
};


export type IssueMutationRootLinkIssueToArticleArgs = {
  command: LinkIssueToArticle;
};


export type IssueMutationRootLinkIssueToBopArgs = {
  command: LinkIssueToBop;
};


export type IssueMutationRootLinkIssueToModuleArgs = {
  command: LinkIssueToModule;
};


export type IssueMutationRootLinkIssueToSerialNumberArgs = {
  command: LinkIssueToSerialNumber;
};


export type IssueMutationRootLinkIssueToSerialNumbersArgs = {
  command: LinkIssueToSerialNumbers;
};


export type IssueMutationRootLinkIssueToStepArgs = {
  command: LinkIssueToStep;
};


export type IssueMutationRootSetIssueCommentResolvedArgs = {
  command: SetIssueResolved;
};


export type IssueMutationRootUpdateIssueArgs = {
  command: UpdateIssue;
};


export type IssueMutationRootUpdateIssueCommentArgs = {
  command: UpdateIssueComment;
};


export type IssueMutationRootUpdateIssueLinkArgs = {
  command: UpdateIssueLink;
};

export type IssueRoot = {
  __typename?: 'IssueRoot';
  issue: Issue;
  issueComment: IssueComment;
  issueLink: IssueLink;
  issues: Array<Issue>;
  issuesPerDay: Array<IssuesPerDay>;
};


export type IssueRootIssueArgs = {
  id: Scalars['ID']['input'];
};


export type IssueRootIssueCommentArgs = {
  id: Scalars['ID']['input'];
};


export type IssueRootIssueLinkArgs = {
  id: Scalars['ID']['input'];
};


export type IssueRootIssuesArgs = {
  query: IssueSearchQuery;
};


export type IssueRootIssuesPerDayArgs = {
  from: Scalars['DateTime']['input'];
  till: Scalars['DateTime']['input'];
};

export type IssueSearchQuery = {
  assignedToUserId?: InputMaybe<Scalars['ID']['input']>;
  bopIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  poNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  serialNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  sortBy?: InputMaybe<IssueSortBy>;
  sortDirection?: InputMaybe<SortDirection>;
};

export enum IssueSortBy {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type IssuesPerDay = {
  __typename?: 'IssuesPerDay';
  created: Scalars['Int']['output'];
  day: Scalars['Instant']['output'];
  open: Scalars['Int']['output'];
  resolved: Scalars['Int']['output'];
};

export enum Language {
  En = 'EN',
  Nl = 'NL'
}

export type LinkIssueToArticle = {
  articleId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
};

export type LinkIssueToBop = {
  bopId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
};

export type LinkIssueToModule = {
  bopId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
};

export type LinkIssueToSerialNumber = {
  bopId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
  poNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  stepId: Scalars['ID']['input'];
};

export type LinkIssueToSerialNumbers = {
  bopId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  issueId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
  poNumber: Scalars['String']['input'];
  serialNumbers: Array<Scalars['String']['input']>;
  stepId: Scalars['ID']['input'];
};

export type LinkIssueToStep = {
  bopId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
  stepId: Scalars['ID']['input'];
};

export type LoadEbomFromCsvCommand = {
  bopId: Scalars['ID']['input'];
  config: CsvConfig;
  uploadId: Scalars['ID']['input'];
};

export type LoadEbomResult = {
  __typename?: 'LoadEbomResult';
  ebom?: Maybe<Ebom>;
  error?: Maybe<Scalars['String']['output']>;
};

export type ManualArticleAllocation = IArticleAllocation & {
  __typename?: 'ManualArticleAllocation';
  article: Article;
  id: Scalars['ID']['output'];
  milliQuantity: Scalars['Int']['output'];
  step: Step;
};

export type Module = {
  __typename?: 'Module';
  abbreviation: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputs: Array<StepInput>;
  issueLinks: Array<IssueLink>;
  name: Scalars['String']['output'];
  nodes: Array<StepNode>;
  outputs: Array<StepOutput>;
};

export type ModuleIssueLink = IssueLinkI & {
  __typename?: 'ModuleIssueLink';
  bop: Bop;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: Issue;
  module: Module;
};

export type ModuleNode = DagNode & {
  __typename?: 'ModuleNode';
  id: Scalars['ID']['output'];
  module: Module;
  parentIds: Array<Scalars['ID']['output']>;
};

export type Move = {
  ids: Array<Scalars['ID']['input']>;
  otherId: Scalars['ID']['input'];
  placement: Placement;
};

export type Mutation = {
  __typename?: 'Mutation';
  account: AccountMutationRoot;
  article: ArticleMutationRoot;
  issue: IssueMutationRoot;
  product: ProductMutationRoot;
  shopFloor: ShopFloorMutationRoot;
  site: SiteMutationRoot;
  upload: UploadMutationRoot;
};

export type NumericCheck = CheckI & {
  __typename?: 'NumericCheck';
  configuration: CheckConfiguration;
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  milliQuantity: Scalars['Int']['output'];
  poNumber: Scalars['String']['output'];
  released: Scalars['Boolean']['output'];
  reportingUser: User;
  serialNumber: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type OrgReachablePermission = {
  __typename?: 'OrgReachablePermission';
  permission: PermissionOrganization;
  reachable: Array<PermissionOrganization>;
};

export type Organization = {
  __typename?: 'Organization';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type OrganizationUserPermissions = {
  __typename?: 'OrganizationUserPermissions';
  organization: Organization;
  permissions: Array<PermissionOrganization>;
};

export type PdfExtension = {
  __typename?: 'PdfExtension';
  analysis: PdfExtensionAnalysis;
};

export type PdfExtensionAnalysis = {
  __typename?: 'PdfExtensionAnalysis';
  errors: Array<Scalars['String']['output']>;
  numberOfImages: Scalars['Int']['output'];
  numberOfPages: Scalars['Int']['output'];
};

export enum PermissionOrganization {
  OrgAdmin = 'ORG_ADMIN',
  OrgArticleDelete = 'ORG_ARTICLE_DELETE',
  OrgArticleRead = 'ORG_ARTICLE_READ',
  OrgArticleWrite = 'ORG_ARTICLE_WRITE',
  OrgEbomDelete = 'ORG_EBOM_DELETE',
  OrgEbomRead = 'ORG_EBOM_READ',
  OrgEbomWrite = 'ORG_EBOM_WRITE',
  OrgIssueComment = 'ORG_ISSUE_COMMENT',
  OrgIssueDelete = 'ORG_ISSUE_DELETE',
  OrgIssueRead = 'ORG_ISSUE_READ',
  OrgIssueWrite = 'ORG_ISSUE_WRITE',
  OrgMbomRead = 'ORG_MBOM_READ',
  OrgMember = 'ORG_MEMBER',
  OrgProductionBatchDelete = 'ORG_PRODUCTION_BATCH_DELETE',
  OrgProductionBatchRead = 'ORG_PRODUCTION_BATCH_READ',
  OrgProductionBatchWrite = 'ORG_PRODUCTION_BATCH_WRITE',
  OrgProductDelete = 'ORG_PRODUCT_DELETE',
  OrgProductRead = 'ORG_PRODUCT_READ',
  OrgProductWrite = 'ORG_PRODUCT_WRITE',
  OrgUploadDelete = 'ORG_UPLOAD_DELETE',
  OrgUploadIndex = 'ORG_UPLOAD_INDEX',
  OrgUploadWrite = 'ORG_UPLOAD_WRITE'
}

export enum PermissionUser {
  UserGlobalAdmin = 'USER_GLOBAL_ADMIN'
}

export enum Placement {
  Above = 'ABOVE',
  Below = 'BELOW'
}

export type Product = {
  __typename?: 'Product';
  abbreviation: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUpload?: Maybe<Upload>;
  imageUploadId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  productConfigurations: Array<ProductConfiguration>;
};

export type ProductConfiguration = {
  __typename?: 'ProductConfiguration';
  abbreviation: Scalars['String']['output'];
  bops: Array<Bop>;
  bopsAtSite: Array<Bop>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUpload?: Maybe<Upload>;
  imageUploadId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  product: Product;
};


export type ProductConfigurationBopsAtSiteArgs = {
  siteId: Scalars['ID']['input'];
};

export type ProductMutationRoot = {
  __typename?: 'ProductMutationRoot';
  /** Top entity id refers to module id, node entity types are steps and entity ids refer to step ids */
  addNodeToModuleGraph: Scalars['Boolean']['output'];
  createCheckConfiguration: CheckConfiguration;
  createImageStepUpload: ImageStepUpload;
  createModule: Module;
  createProduct: Product;
  createProductConfiguration: ProductConfiguration;
  createStep: Step;
  createStepInput: StepInput;
  createStepOutput: StepOutput;
  createStepProposalsFromMedia: StepProposalResult;
  createStepProposalsFromPDF: StepProposalResult;
  createStepType: StepType;
  createVideoStepUpload: VideoStepUpload;
  createVideoStepUploads: Array<VideoStepUpload>;
  deleteCheckConfiguration: Scalars['ID']['output'];
  /** Deletes latest BOP version, only if it is not released */
  deleteLatestUnreleasedBOPVersion?: Maybe<Scalars['ID']['output']>;
  deleteModule?: Maybe<Scalars['ID']['output']>;
  deleteProduct: Scalars['ID']['output'];
  deleteProductConfiguration: Scalars['ID']['output'];
  deleteStep?: Maybe<Scalars['ID']['output']>;
  deleteStepInput: Scalars['ID']['output'];
  deleteStepOutput: Scalars['ID']['output'];
  deleteStepType: Scalars['ID']['output'];
  deleteStepUpload: Scalars['ID']['output'];
  /** Creates a new BOP draft, only if a new lineage is started or previous version was released */
  draftBOP: Bop;
  /** Creates a new BOP draft by duplicating another BOP, only if it starts a new lineage */
  draftBOPByDuplicating: Bop;
  duplicateModule: Module;
  duplicateStep: Step;
  moveCheckConfiguration: Scalars['Boolean']['output'];
  moveStepUpload: Scalars['Boolean']['output'];
  releaseLatestBOPVersion: Bop;
  /** Top entity id refers to BOP id, node entity types are modules and entity ids refer to module ids */
  setBillOfProcessGraph: Scalars['Boolean']['output'];
  /** Top entity id refers to module id, node entity types are steps and entity ids refer to step ids */
  setModuleGraph: Scalars['Boolean']['output'];
  setStepDurations: Scalars['Boolean']['output'];
  updateCheckConfiguration: CheckConfiguration;
  updateImageStepUpload: ImageStepUpload;
  updateModule: Module;
  updateProduct: Product;
  updateProductConfiguration: ProductConfiguration;
  updateStep: Step;
  updateStepInput: StepInput;
  updateStepOutput: StepOutput;
  updateStepType: StepType;
  updateVideoStepUpload: VideoStepUpload;
};


export type ProductMutationRootAddNodeToModuleGraphArgs = {
  command: AddTreeGraphNode;
};


export type ProductMutationRootCreateCheckConfigurationArgs = {
  command: CreateCheckConfigurationCommand;
};


export type ProductMutationRootCreateImageStepUploadArgs = {
  command: CreateImageStepUpload;
};


export type ProductMutationRootCreateModuleArgs = {
  command: CreateModule;
};


export type ProductMutationRootCreateProductArgs = {
  command: CreateProduct;
};


export type ProductMutationRootCreateProductConfigurationArgs = {
  command: CreateProductConfiguration;
};


export type ProductMutationRootCreateStepArgs = {
  command: CreateStep;
};


export type ProductMutationRootCreateStepInputArgs = {
  command: CreateStepInput;
};


export type ProductMutationRootCreateStepOutputArgs = {
  command: CreateStepOutput;
};


export type ProductMutationRootCreateStepProposalsFromMediaArgs = {
  command: CreateStepProposalsFromMedia;
};


export type ProductMutationRootCreateStepProposalsFromPdfArgs = {
  command: CreateStepProposalsFromPdf;
};


export type ProductMutationRootCreateStepTypeArgs = {
  command: CreateStepType;
};


export type ProductMutationRootCreateVideoStepUploadArgs = {
  command: CreateVideoStepUpload;
};


export type ProductMutationRootCreateVideoStepUploadsArgs = {
  commands: Array<CreateVideoStepUpload>;
};


export type ProductMutationRootDeleteCheckConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteLatestUnreleasedBopVersionArgs = {
  atSiteId: Scalars['ID']['input'];
  forProductConfigId: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteModuleArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteProductArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteProductConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteStepArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteStepInputArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteStepOutputArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteStepTypeArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDeleteStepUploadArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationRootDraftBopArgs = {
  atSiteId: Scalars['ID']['input'];
  forProductConfigId: Scalars['ID']['input'];
};


export type ProductMutationRootDraftBopByDuplicatingArgs = {
  command: DraftBopByDuplicating;
};


export type ProductMutationRootDuplicateModuleArgs = {
  command: DuplicateModule;
};


export type ProductMutationRootDuplicateStepArgs = {
  command: DuplicateStep;
};


export type ProductMutationRootMoveCheckConfigurationArgs = {
  command: Move;
  inStepId: Scalars['ID']['input'];
};


export type ProductMutationRootMoveStepUploadArgs = {
  command: Move;
  inStepId: Scalars['ID']['input'];
};


export type ProductMutationRootReleaseLatestBopVersionArgs = {
  atSiteId: Scalars['ID']['input'];
  forProductConfigId: Scalars['ID']['input'];
};


export type ProductMutationRootSetBillOfProcessGraphArgs = {
  command: SetDagGraph;
};


export type ProductMutationRootSetModuleGraphArgs = {
  command: SetTreeGraph;
};


export type ProductMutationRootSetStepDurationsArgs = {
  command: SetStepDurations;
};


export type ProductMutationRootUpdateCheckConfigurationArgs = {
  command: UpdateCheckConfigurationCommand;
};


export type ProductMutationRootUpdateImageStepUploadArgs = {
  command: UpdateImageStepUpload;
};


export type ProductMutationRootUpdateModuleArgs = {
  command: UpdateModule;
};


export type ProductMutationRootUpdateProductArgs = {
  command: UpdateProduct;
};


export type ProductMutationRootUpdateProductConfigurationArgs = {
  command: UpdateProductConfiguration;
};


export type ProductMutationRootUpdateStepArgs = {
  command: UpdateStep;
};


export type ProductMutationRootUpdateStepInputArgs = {
  command: UpdateStepInput;
};


export type ProductMutationRootUpdateStepOutputArgs = {
  command: UpdateStepOutput;
};


export type ProductMutationRootUpdateStepTypeArgs = {
  command: UpdateStepType;
};


export type ProductMutationRootUpdateVideoStepUploadArgs = {
  command: UpdateVideoStepUpload;
};

export type ProductRoot = {
  __typename?: 'ProductRoot';
  bop: Bop;
  checkConfigurations: Array<CheckConfiguration>;
  createStepProposalsFromMediaSupportedMimeTypes: Array<Scalars['String']['output']>;
  imageStepUpload: ImageStepUpload;
  module: Module;
  modules: Array<Module>;
  product: Product;
  productConfiguration: ProductConfiguration;
  products: Array<Product>;
  step: Step;
  stepInput: StepInput;
  stepOutput: StepOutput;
  stepTypes: Array<StepType>;
  steps?: Maybe<Array<Step>>;
  videoStepUpload: VideoStepUpload;
};


export type ProductRootBopArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootCheckConfigurationsArgs = {
  stepId: Scalars['ID']['input'];
};


export type ProductRootImageStepUploadArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootModuleArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootModulesArgs = {
  productId: Scalars['ID']['input'];
};


export type ProductRootProductArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootProductConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootStepArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootStepInputArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootStepOutputArgs = {
  id: Scalars['ID']['input'];
};


export type ProductRootStepsArgs = {
  productId: Scalars['ID']['input'];
};


export type ProductRootVideoStepUploadArgs = {
  id: Scalars['ID']['input'];
};

export type ProductionBatch = {
  __typename?: 'ProductionBatch';
  assignedUser?: Maybe<User>;
  bop: Bop;
  completed: Scalars['Boolean']['output'];
  currentStep?: Maybe<Step>;
  id: Scalars['ID']['output'];
  module: Module;
  poNumber: Scalars['String']['output'];
  serialNumbers: Array<Scalars['String']['output']>;
};

export type ProductionBatchPage = {
  __typename?: 'ProductionBatchPage';
  data: Array<ProductionBatch>;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  itemsPerPage: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ProductionBatchQuery = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  itemsPerPage: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  poNumberContains?: InputMaybe<Scalars['String']['input']>;
  serialNumberContains?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  account: AccountRoot;
  article: ArticleRoot;
  exception: Scalars['Boolean']['output'];
  issue: IssueRoot;
  product: ProductRoot;
  shopFloor: ShopFloorRoot;
  site: SiteRoot;
  upload: UploadRoot;
};

export type ReplaceEbomPartAllocation = {
  newEbomPartId: Scalars['ID']['input'];
  oldEbomPartId: Scalars['ID']['input'];
};

export type ReplaceEbomPartAllocationsCommand = {
  replacements: Array<ReplaceEbomPartAllocation>;
};

export type SerialNumberIssueLink = IssueLinkI & {
  __typename?: 'SerialNumberIssueLink';
  bop: Bop;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: Issue;
  module: Module;
  poNumber: Scalars['String']['output'];
  serialNumber: Scalars['String']['output'];
  step: Step;
};

export type SetConfirmCheckCommand = {
  checkConfigurationId: Scalars['ID']['input'];
  confirmed: Scalars['Boolean']['input'];
  poNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type SetDagGraph = {
  entityId: Scalars['ID']['input'];
  nodes: Array<SetDagGraphNode>;
};

export type SetDagGraphNode = {
  entityId: Scalars['ID']['input'];
  entityType: GraphEntityType;
  id: Scalars['ID']['input'];
  parentIds: Array<Scalars['ID']['input']>;
};

export type SetIssueResolved = {
  id: Scalars['ID']['input'];
  resolved: Scalars['Boolean']['input'];
};

export type SetNumericCheckCommand = {
  checkConfigurationId: Scalars['ID']['input'];
  milliQuantity: Scalars['Int']['input'];
  poNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
};

export type SetOrganizationPermissions = {
  orgId: Scalars['ID']['input'];
  permissions: Array<PermissionOrganization>;
  userId: Scalars['ID']['input'];
};

export type SetStepDuration = {
  durationInSeconds: Scalars['Int']['input'];
  stepId: Scalars['ID']['input'];
};

export type SetStepDurations = {
  durations: Array<SetStepDuration>;
};

export type SetStringCheckCommand = {
  checkConfigurationId: Scalars['ID']['input'];
  poNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type SetTreeGraph = {
  entityId: Scalars['ID']['input'];
  nodes: Array<SetTreeGraphNode>;
};

export type SetTreeGraphNode = {
  entityId: Scalars['ID']['input'];
  entityType: GraphEntityType;
  id: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type SetUserPermissions = {
  permissions: Array<PermissionUser>;
  userId: Scalars['ID']['input'];
};

export type ShopFloorMutationRoot = {
  __typename?: 'ShopFloorMutationRoot';
  createProductionBatch: ProductionBatch;
  deleteCheck: Scalars['Boolean']['output'];
  deleteProductionBatch: Scalars['ID']['output'];
  setConfirmCheck: ConfirmCheck;
  setNumericCheck: NumericCheck;
  setStringCheck: StringCheck;
  transferProductionBatch: ProductionBatch;
  updateProductionBatch: ProductionBatch;
};


export type ShopFloorMutationRootCreateProductionBatchArgs = {
  command: CreateProductionBatchCommand;
};


export type ShopFloorMutationRootDeleteCheckArgs = {
  command: DeleteCheckCommand;
};


export type ShopFloorMutationRootDeleteProductionBatchArgs = {
  id: Scalars['ID']['input'];
};


export type ShopFloorMutationRootSetConfirmCheckArgs = {
  command: SetConfirmCheckCommand;
};


export type ShopFloorMutationRootSetNumericCheckArgs = {
  command: SetNumericCheckCommand;
};


export type ShopFloorMutationRootSetStringCheckArgs = {
  command: SetStringCheckCommand;
};


export type ShopFloorMutationRootTransferProductionBatchArgs = {
  command: TransferProductionBatchCommand;
};


export type ShopFloorMutationRootUpdateProductionBatchArgs = {
  command: UpdateProductionBatchCommand;
};

export type ShopFloorRoot = {
  __typename?: 'ShopFloorRoot';
  check: Check;
  checks: Array<Check>;
  productionBatch?: Maybe<ProductionBatch>;
  productionBatches: ProductionBatchPage;
  productionBatchesInProgressForCurrentUser: Array<ProductionBatch>;
  productionBatchesInProgressForUser: Array<ProductionBatch>;
};


export type ShopFloorRootCheckArgs = {
  id: Scalars['ID']['input'];
};


export type ShopFloorRootChecksArgs = {
  query?: InputMaybe<CheckSearchQuery>;
};


export type ShopFloorRootProductionBatchArgs = {
  id: Scalars['ID']['input'];
};


export type ShopFloorRootProductionBatchesArgs = {
  query: ProductionBatchQuery;
};


export type ShopFloorRootProductionBatchesInProgressForUserArgs = {
  userId: Scalars['ID']['input'];
};

export type Site = {
  __typename?: 'Site';
  abbreviation: Scalars['String']['output'];
  archived: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tools: Array<Tool>;
};

export type SiteMutationRoot = {
  __typename?: 'SiteMutationRoot';
  createSite: Site;
  createTool: Tool;
  deleteSite: Scalars['ID']['output'];
  deleteTool: Scalars['ID']['output'];
  updateSite: Site;
  updateTool: Tool;
};


export type SiteMutationRootCreateSiteArgs = {
  command: CreateSite;
};


export type SiteMutationRootCreateToolArgs = {
  command: CreateTool;
};


export type SiteMutationRootDeleteSiteArgs = {
  id: Scalars['ID']['input'];
};


export type SiteMutationRootDeleteToolArgs = {
  id: Scalars['ID']['input'];
};


export type SiteMutationRootUpdateSiteArgs = {
  command: UpdateSite;
};


export type SiteMutationRootUpdateToolArgs = {
  command: UpdateTool;
};

export type SiteRoot = {
  __typename?: 'SiteRoot';
  site: Site;
  sites: Array<Site>;
  tool: Tool;
};


export type SiteRootSiteArgs = {
  id: Scalars['ID']['input'];
};


export type SiteRootToolArgs = {
  id: Scalars['ID']['input'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Step = {
  __typename?: 'Step';
  articleAllocations: Array<ArticleAllocation>;
  checkConfigurations: Array<CheckConfiguration>;
  durationInSeconds: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inputs: Array<StepInput>;
  instructionText?: Maybe<Scalars['String']['output']>;
  issueLinks: Array<IssueLink>;
  module: Module;
  name: Scalars['String']['output'];
  outputs: Array<StepOutput>;
  stepType: StepType;
  toolIds: Array<Scalars['ID']['output']>;
  tools: Array<Tool>;
  uploads: Array<StepUpload>;
};

export type StepInput = {
  __typename?: 'StepInput';
  id: Scalars['ID']['output'];
  milliQuantity: Scalars['Int']['output'];
  module: Module;
  output: StepOutput;
  step: Step;
};

export type StepIssueLink = IssueLinkI & {
  __typename?: 'StepIssueLink';
  bop: Bop;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: Issue;
  module: Module;
  step: Step;
};

export type StepNode = TreeNode & {
  __typename?: 'StepNode';
  id: Scalars['ID']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  step: Step;
};

export type StepOutput = {
  __typename?: 'StepOutput';
  article: Article;
  id: Scalars['ID']['output'];
  milliQuantity: Scalars['Int']['output'];
  module: Module;
  step: Step;
};

export type StepProposal = {
  __typename?: 'StepProposal';
  durationInSeconds: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  instructionText?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  videoUploadProposals: Array<VideoStepUploadProposal>;
};

export type StepProposalResult = {
  __typename?: 'StepProposalResult';
  errors: Array<Scalars['String']['output']>;
  proposals: Array<StepProposal>;
};

export type StepType = {
  __typename?: 'StepType';
  archived: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  released: Scalars['Boolean']['output'];
};

export type StepUpload = ImageStepUpload | VideoStepUpload;

export type StringCheck = CheckI & {
  __typename?: 'StringCheck';
  configuration: CheckConfiguration;
  createdAt: Scalars['Instant']['output'];
  id: Scalars['ID']['output'];
  poNumber: Scalars['String']['output'];
  released: Scalars['Boolean']['output'];
  reportingUser: User;
  serialNumber: Scalars['String']['output'];
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Instant']['output']>;
};

export type Tool = {
  __typename?: 'Tool';
  archived: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUploads: Array<Upload>;
  name: Scalars['String']['output'];
  released: Scalars['Boolean']['output'];
};

export type TransferProductionBatchCommand = {
  assignedUserId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type TreeGraph = {
  nodes: Array<TreeNode>;
};

export type TreeNode = {
  id: Scalars['ID']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
};

export type UpdateArticle = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  unit: ArticleUnit;
};

export type UpdateCheckConfigurationCommand = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isRequired: Scalars['Boolean']['input'];
  lowerLimit?: InputMaybe<Scalars['Int']['input']>;
  upperLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateImageStepUpload = {
  caption?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateIssue = {
  assignedToUserIds: Array<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  resolved: Scalars['Boolean']['input'];
  uploadIds: Array<Scalars['ID']['input']>;
};

export type UpdateIssueComment = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  resolved: Scalars['Boolean']['input'];
  uploadIds: Array<Scalars['ID']['input']>;
};

export type UpdateIssueLink = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateModule = {
  abbreviation: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateOrganization = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type UpdateProduct = {
  abbreviation: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUploadId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateProductConfiguration = {
  abbreviation: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUploadId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateProductionBatchCommand = {
  assignedUserId?: InputMaybe<Scalars['ID']['input']>;
  completed: Scalars['Boolean']['input'];
  currentStepId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateSite = {
  abbreviation: Scalars['String']['input'];
  archived: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateStep = {
  durationInSeconds: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  instructionText?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  stepTypeId: Scalars['ID']['input'];
  toolIds: Array<Scalars['ID']['input']>;
};

export type UpdateStepInput = {
  id: Scalars['ID']['input'];
  milliQuantity: Scalars['Int']['input'];
};

export type UpdateStepOutput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  milliQuantity: Scalars['Int']['input'];
};

export type UpdateStepType = {
  archived: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateTool = {
  archived: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageUploadIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateUpload = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateUser = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  lastname: Scalars['String']['input'];
};

export type UpdateVideoStepUpload = {
  caption?: InputMaybe<Scalars['String']['input']>;
  fragmentEndInMillis?: InputMaybe<Scalars['Int']['input']>;
  fragmentLoop?: InputMaybe<Scalars['Boolean']['input']>;
  fragmentStartInMillis?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};

export type Upload = {
  __typename?: 'Upload';
  contentType: Scalars['String']['output'];
  createdAt: Scalars['Instant']['output'];
  extension: UploadExtension;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};


export type UploadImageUrlArgs = {
  options: ImageOptions;
};

export type UploadExtension = CsvExtension | GenericExtension | ImageExtension | PdfExtension | VideoExtension;

export type UploadMutationRoot = {
  __typename?: 'UploadMutationRoot';
  createMultipartUpload: Scalars['ID']['output'];
  deleteUpload: Scalars['ID']['output'];
  finalizeMultipartUpload: Upload;
  updateUpload: Upload;
};


export type UploadMutationRootCreateMultipartUploadArgs = {
  command: CreateMultipartUpload;
};


export type UploadMutationRootDeleteUploadArgs = {
  id: Scalars['ID']['input'];
};


export type UploadMutationRootFinalizeMultipartUploadArgs = {
  id: Scalars['ID']['input'];
};


export type UploadMutationRootUpdateUploadArgs = {
  command: UpdateUpload;
};

export type UploadQuery = {
  inContentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  results: Scalars['Int']['input'];
  sortBy: UploadSortField;
  sortDirection: UploadSortDirection;
};

export type UploadRoot = {
  __typename?: 'UploadRoot';
  search: Array<Upload>;
  upload: Upload;
  uploads: Array<Upload>;
};


export type UploadRootSearchArgs = {
  query: UploadQuery;
};


export type UploadRootUploadArgs = {
  id: Scalars['ID']['input'];
};


export type UploadRootUploadsArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export enum UploadSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum UploadSortField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
};

export type UserSearchCriteria = {
  contains?: InputMaybe<Scalars['String']['input']>;
};

export enum VersionStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Released = 'RELEASED',
  Review = 'REVIEW'
}

export type VideoExtension = {
  __typename?: 'VideoExtension';
  url: Scalars['String']['output'];
};

export type VideoStepUpload = IStepUpload & {
  __typename?: 'VideoStepUpload';
  caption?: Maybe<Scalars['String']['output']>;
  fragmentEndInMillis?: Maybe<Scalars['Int']['output']>;
  fragmentLoop?: Maybe<Scalars['Boolean']['output']>;
  fragmentStartInMillis?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  upload: Upload;
};

export type VideoStepUploadProposal = {
  __typename?: 'VideoStepUploadProposal';
  fragmentEndInMillis?: Maybe<Scalars['Int']['output']>;
  fragmentStartInMillis?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  upload: Upload;
};

export type BreadcrumbDataQueryVariables = Exact<{
  includeConfig: Scalars['Boolean']['input'];
  configId: Scalars['ID']['input'];
  includeBop: Scalars['Boolean']['input'];
  siteId: Scalars['ID']['input'];
  includeSite: Scalars['Boolean']['input'];
  bopId: Scalars['ID']['input'];
  includeEbom: Scalars['Boolean']['input'];
}>;


export type BreadcrumbDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', products: Array<{ __typename?: 'Product', id: string, name: string, productConfigurations: Array<{ __typename?: 'ProductConfiguration', id: string, name: string }> }>, productConfiguration?: { __typename?: 'ProductConfiguration', name: string, bops: Array<{ __typename?: 'BOP', id: string, version: number, versionStatus: VersionStatus, site: { __typename?: 'Site', id: string, name: string } }> }, bop?: { __typename?: 'BOP', version: number, versionStatus: VersionStatus, nodes: Array<{ __typename?: 'ModuleNode', module: { __typename?: 'Module', id: string, name: string } }> } }, article: { __typename?: 'ArticleRoot', ebomsForBop?: Array<{ __typename?: 'Ebom', id: string, name: string }> }, site: { __typename?: 'SiteRoot', site?: { __typename?: 'Site', id: string, name: string } } };

export type TestExceptionQueryVariables = Exact<{ [key: string]: never; }>;


export type TestExceptionQuery = { __typename?: 'Query', exception: boolean };

export type ArticleAllocationListDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
}>;


export type ArticleAllocationListDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', articleAllocations: Array<{ __typename: 'EbomPartAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string, name?: string, unit: ArticleUnit, type: ArticleType }, ebomPart: { __typename?: 'EbomPart', id: string, ebomId: string, articleNumber: string, revision: string, name?: string, unit: ArticleUnit, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> } } } | { __typename: 'ManualArticleAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string, name?: string, unit: ArticleUnit, type: ArticleType } }> } } };

export type PartAllocationListAllocationMutationMutationVariables = Exact<{
  command: AllocateArticleToStepCommand;
}>;


export type PartAllocationListAllocationMutationMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', allocateArticleToStep: boolean } };

export type ArticleAllocationListDeleteEbomAllocationMutationVariables = Exact<{
  command: AllocateEbomPartToStepCommand;
}>;


export type ArticleAllocationListDeleteEbomAllocationMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', allocateEbomPartToStep: boolean } };

export type CreateArticleDialogTakenQueryVariables = Exact<{
  articleNumber: Scalars['String']['input'];
  revision: Scalars['String']['input'];
}>;


export type CreateArticleDialogTakenQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', articles: Array<{ __typename?: 'Article', id: string }> } };

export type ArticleViewCreateArticleMutationVariables = Exact<{
  command: CreateArticle;
}>;


export type ArticleViewCreateArticleMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', createArticle: { __typename?: 'Article', id: string, articleNumber: string, revision: string, name?: string } } };

export type EbomPartAllocationRowDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
}>;


export type EbomPartAllocationRowDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebomsForBop: Array<{ __typename?: 'Ebom', id: string, name: string }> } };

export type EbomPartAllocationRowAllocationMutationVariables = Exact<{
  command: AllocateEbomPartToStepCommand;
}>;


export type EbomPartAllocationRowAllocationMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', allocateEbomPartToStep: boolean } };

export type ManualArticleAllocationRowAllocationMutationVariables = Exact<{
  command: AllocateArticleToStepCommand;
}>;


export type ManualArticleAllocationRowAllocationMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', allocateArticleToStep: boolean } };

export type BopModulesTimeChartDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
}>;


export type BopModulesTimeChartDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', nodes: Array<{ __typename?: 'ModuleNode', module: { __typename?: 'Module', id: string, name: string, nodes: Array<{ __typename?: 'StepNode', id: string, step: { __typename?: 'Step', id: string, name: string, durationInSeconds: number } }> } }> } } };

export type BopNavigationDrawerDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
  includeIssues: Scalars['Boolean']['input'];
  includeEboms: Scalars['Boolean']['input'];
}>;


export type BopNavigationDrawerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', versionStatus: VersionStatus, issueLinks?: Array<{ __typename?: 'ArticleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } } | { __typename?: 'BOPIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } } | { __typename?: 'ModuleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } } | { __typename?: 'SerialNumberIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } } | { __typename?: 'StepIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } }> } }, article: { __typename?: 'ArticleRoot', ebomsForBop?: Array<{ __typename?: 'Ebom', id: string, name: string, sourceType: EbomSourceType, sourceId: string }> } };

export type DeleteEbomMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEbomMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', deleteEbom: string } };

export type BopReleaseConfirmationDataQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
  productConfigurationId: Scalars['ID']['input'];
  bopId: Scalars['ID']['input'];
}>;


export type BopReleaseConfirmationDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', product: { __typename?: 'Product', name: string }, productConfiguration: { __typename?: 'ProductConfiguration', name: string }, bop: { __typename?: 'BOP', version: number, site: { __typename?: 'Site', id: string, name: string } } } };

export type BopReleaseConfirmationReleaseMutationVariables = Exact<{
  configId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type BopReleaseConfirmationReleaseMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', releaseLatestBOPVersion: { __typename?: 'BOP', id: string } } };

export type CheckDialogDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CheckDialogDataQuery = { __typename?: 'Query', shopFloor: { __typename?: 'ShopFloorRoot', check: { __typename: 'ConfirmCheck', id: string, released: boolean, serialNumber: string, poNumber: string, createdAt: any, updatedAt?: any, confirmed: boolean, reportingUser: { __typename?: 'User', id: string, firstname: string, lastname: string }, configuration: { __typename?: 'CheckConfiguration', id: string, description: string, isRequired: boolean, lowerLimit?: number, upperLimit?: number, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } } } | { __typename: 'NumericCheck', id: string, released: boolean, serialNumber: string, poNumber: string, createdAt: any, updatedAt?: any, milliQuantity: number, reportingUser: { __typename?: 'User', id: string, firstname: string, lastname: string }, configuration: { __typename?: 'CheckConfiguration', id: string, description: string, isRequired: boolean, lowerLimit?: number, upperLimit?: number, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } } } | { __typename: 'StringCheck', id: string, released: boolean, serialNumber: string, poNumber: string, createdAt: any, updatedAt?: any, text: string, reportingUser: { __typename?: 'User', id: string, firstname: string, lastname: string }, configuration: { __typename?: 'CheckConfiguration', id: string, description: string, isRequired: boolean, lowerLimit?: number, upperLimit?: number, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } } } } };

export type ConfirmationCheckSetMutationVariables = Exact<{
  command: SetConfirmCheckCommand;
}>;


export type ConfirmationCheckSetMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', setConfirmCheck: { __typename?: 'ConfirmCheck', id: string } } };

export type ConfirmationCheckDeleteMutationVariables = Exact<{
  command: DeleteCheckCommand;
}>;


export type ConfirmationCheckDeleteMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', deleteCheck: boolean } };

export type NumericCheckSetMutationVariables = Exact<{
  command: SetNumericCheckCommand;
}>;


export type NumericCheckSetMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', setNumericCheck: { __typename?: 'NumericCheck', id: string } } };

export type NumericCheckDeleteMutationVariables = Exact<{
  command: DeleteCheckCommand;
}>;


export type NumericCheckDeleteMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', deleteCheck: boolean } };

export type CheckDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
}>;


export type CheckDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', checkConfigurations: Array<{ __typename?: 'CheckConfiguration', id: string, type: CheckType, isRequired: boolean, description: string, lowerLimit?: number, upperLimit?: number, unreleasedChecks: Array<{ __typename?: 'ConfirmCheck', id: string, poNumber: string, serialNumber: string, confirmed: boolean } | { __typename?: 'NumericCheck', id: string, poNumber: string, serialNumber: string, milliQuantity: number } | { __typename?: 'StringCheck', id: string, poNumber: string, serialNumber: string, text: string }> }> } };

export type StringCheckSetMutationVariables = Exact<{
  command: SetStringCheckCommand;
}>;


export type StringCheckSetMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', setStringCheck: { __typename?: 'StringCheck', id: string } } };

export type StringCheckDeleteMutationVariables = Exact<{
  command: DeleteCheckCommand;
}>;


export type StringCheckDeleteMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', deleteCheck: boolean } };

export type StepCheckConfigurationsDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
}>;


export type StepCheckConfigurationsDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', checkConfigurations: Array<{ __typename?: 'CheckConfiguration', id: string, type: CheckType, isRequired: boolean, description: string, upperLimit?: number, lowerLimit?: number, order: number }> } };

export type CreateCheckConfigurationMutationVariables = Exact<{
  command: CreateCheckConfigurationCommand;
}>;


export type CreateCheckConfigurationMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createCheckConfiguration: { __typename?: 'CheckConfiguration', id: string } } };

export type UpdateCheckConfigurationMutationVariables = Exact<{
  command: UpdateCheckConfigurationCommand;
}>;


export type UpdateCheckConfigurationMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateCheckConfiguration: { __typename?: 'CheckConfiguration', id: string } } };

export type MoveCheckConfigurationMutationVariables = Exact<{
  stepId: Scalars['ID']['input'];
  command: Move;
}>;


export type MoveCheckConfigurationMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', moveCheckConfiguration: boolean } };

export type DeleteCheckConfigurationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCheckConfigurationMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteCheckConfiguration: string } };

export type ViewCheckConfigurationsDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
}>;


export type ViewCheckConfigurationsDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', checkConfigurations: Array<{ __typename?: 'CheckConfiguration', id: string, type: CheckType, isRequired: boolean, description: string, upperLimit?: number, lowerLimit?: number }> } };

export type CsvEbomLoaderGetCsvColumnNamesQueryVariables = Exact<{
  uploadId: Scalars['ID']['input'];
}>;


export type CsvEbomLoaderGetCsvColumnNamesQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', upload: { __typename?: 'Upload', id: string, extension: { __typename?: 'CsvExtension', columnNames: Array<string> } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension' } } } };

export type CsvEbomLoaderLoadEbomMutationVariables = Exact<{
  command: LoadEbomFromCsvCommand;
}>;


export type CsvEbomLoaderLoadEbomMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', loadEbomFromCsv: { __typename?: 'LoadEbomResult', error?: string, ebom?: { __typename?: 'Ebom', id: string, ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string, revision: string, milliQuantity: number, name?: string, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, article?: { __typename?: 'Article', id: string } }> } } } };

export type EbomBulkAllocatePartTreeDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EbomBulkAllocatePartTreeDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebom: { __typename?: 'Ebom', ebomParts: Array<{ __typename?: 'EbomPart', id: string, parentId?: string, articleNumber: string, name?: string, revision: string, unit: ArticleUnit, milliQuantity: number, article?: { __typename?: 'Article', id: string }, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', unit: ArticleUnit } }> }> } } };

export type EbomBulkAllocateStepTreeDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EbomBulkAllocateStepTreeDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', nodes: Array<{ __typename?: 'ModuleNode', id: string, parentIds: Array<string>, module: { __typename?: 'Module', id: string, name: string, description?: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, step: { __typename?: 'Step', id: string, name: string } }> } }> } } };

export type EbomBulkAllocateStepTreeNodeAllocateMutationVariables = Exact<{
  command: BulkAllocateEbomPartsToStepCommand;
}>;


export type EbomBulkAllocateStepTreeNodeAllocateMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', bulkAllocateEbomPartsToStep: boolean } };

export type EbomDiffDialogDataQueryVariables = Exact<{
  ebomId: Scalars['ID']['input'];
  bopId: Scalars['ID']['input'];
}>;


export type EbomDiffDialogDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebom: { __typename?: 'Ebom', id: string, name: string }, ebomsForBop: Array<{ __typename?: 'Ebom', id: string, name: string, sourceType: EbomSourceType, sourceId: string }> } };

export type EbomDiffSamePartsMutationVariables = Exact<{
  replacements: Array<ReplaceEbomPartAllocation> | ReplaceEbomPartAllocation;
}>;


export type EbomDiffSamePartsMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', replaceEbomPartAllocations: boolean } };

export type EbomDiffTreeDataQueryVariables = Exact<{
  oldEbomId: Scalars['ID']['input'];
  newEbomId: Scalars['ID']['input'];
}>;


export type EbomDiffTreeDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', oldEbom: { __typename?: 'Ebom', id: string, name: string, ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string, unit: ArticleUnit, revision: string, name?: string, milliQuantity: number, article?: { __typename?: 'Article', id: string }, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', unit: ArticleUnit } }> }> }, newEbom: { __typename?: 'Ebom', id: string, name: string, ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string, unit: ArticleUnit, revision: string, name?: string, milliQuantity: number, article?: { __typename?: 'Article', id: string }, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', unit: ArticleUnit } }> }> } } };

export type EbomPartDataFragment = { __typename?: 'Ebom', id: string, name: string, ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string, unit: ArticleUnit, revision: string, name?: string, milliQuantity: number, article?: { __typename?: 'Article', id: string }, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', unit: ArticleUnit } }> }> };

export type EbomDiffViewerDataQueryVariables = Exact<{
  oldEbomId: Scalars['ID']['input'];
  newEbomId: Scalars['ID']['input'];
}>;


export type EbomDiffViewerDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', oldEbom: { __typename?: 'Ebom', id: string, name: string, sourceType: EbomSourceType, sourceId: string }, newEbom: { __typename?: 'Ebom', id: string, name: string, sourceType: EbomSourceType, sourceId: string } } };

export type EbomDataFragment = { __typename?: 'Ebom', id: string, name: string, sourceType: EbomSourceType, sourceId: string };

export type EbomPartAllocationSuggestionsLoaderCreateSuggestionsMutationVariables = Exact<{
  ebomId: Scalars['ID']['input'];
}>;


export type EbomPartAllocationSuggestionsLoaderCreateSuggestionsMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', createEbomPartAllocationSuggestions: Array<{ __typename?: 'EbomPartAllocationSuggestion', source: EbomPartAllocationSuggestionSource }> } };

export type EbomPartDetailsModulesAndStepsQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
}>;


export type EbomPartDetailsModulesAndStepsQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', nodes: Array<{ __typename?: 'ModuleNode', module: { __typename?: 'Module', id: string, name: string, nodes: Array<{ __typename?: 'StepNode', step: { __typename?: 'Step', id: string, name: string } }> } }> } } };

export type EbomPartDetailsEbomPartQueryVariables = Exact<{
  ebomPartId: Scalars['ID']['input'];
}>;


export type EbomPartDetailsEbomPartQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebomPart: { __typename?: 'EbomPart', id: string, articleNumber: string, revision: string, name?: string, milliQuantity: number, unit: ArticleUnit, snoozeStatus: EbomPartSnoozeStatus, article?: { __typename?: 'Article', id: string }, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', milliQuantity: number, step: { __typename?: 'Step', id: string, name: string } }>, stepAllocationSuggestions: Array<{ __typename?: 'EbomPartAllocationSuggestion', id: string, source: EbomPartAllocationSuggestionSource, decision: EbomPartAllocationSuggestionDecision, milliQuantity: number, step: { __typename?: 'Step', id: string, name: string } }> } } };

export type EbomPartDetailsPromoteToArticlesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EbomPartDetailsPromoteToArticlesMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', promoteEbomPartsToArticles: Array<{ __typename?: 'EbomPart', id: string }> } };

export type EbomPartDetailsAllocateEbomPartToStepMutationVariables = Exact<{
  command: AllocateEbomPartToStepCommand;
}>;


export type EbomPartDetailsAllocateEbomPartToStepMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', allocateEbomPartToStep: boolean } };

export type EbomPartDetailsAcceptSuggestionMutationVariables = Exact<{
  command: AcceptEbomPartAllocationSuggestionCommand;
}>;


export type EbomPartDetailsAcceptSuggestionMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', acceptEbomPartAllocationSuggestion: { __typename?: 'EbomPartAllocationSuggestion', decision: EbomPartAllocationSuggestionDecision } } };

export type EbomPartDetailsRejectSuggestionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EbomPartDetailsRejectSuggestionMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', rejectEbomPartAllocationSuggestion: { __typename?: 'EbomPartAllocationSuggestion', decision: EbomPartAllocationSuggestionDecision } } };

export type EbomPartDetailsSnoozesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EbomPartDetailsSnoozesMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', snoozeEbomParts: boolean } };

export type EbomPartDetailsUnsnoozeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EbomPartDetailsUnsnoozeMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', unsnoozeEbomParts: boolean } };

export type EbomPartTreeEbomPartsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EbomPartTreeEbomPartsQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebom: { __typename?: 'Ebom', ebomParts: Array<{ __typename?: 'EbomPart', id: string, parentId?: string, articleNumber: string, name?: string, revision: string, milliQuantity: number, unit: ArticleUnit, snoozeStatus: EbomPartSnoozeStatus, article?: { __typename?: 'Article', id: string }, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', milliQuantity: number }>, stepAllocationSuggestions: Array<{ __typename?: 'EbomPartAllocationSuggestion', decision: EbomPartAllocationSuggestionDecision }> }> } } };

export type PromoteEbomPartsEbomQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PromoteEbomPartsEbomQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebom: { __typename?: 'Ebom', id: string, ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string, revision: string, milliQuantity: number, unit: ArticleUnit, name?: string, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, article?: { __typename?: 'Article', id: string } }> } } };

export type PromoteEbomPartsPromotionMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PromoteEbomPartsPromotionMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', promoteEbomPartsToArticles: Array<{ __typename?: 'EbomPart', id: string, article?: { __typename?: 'Article', id: string, name?: string } }> } };

export type BulkAllocationSuggestionActionsDataQueryVariables = Exact<{
  ebomId: Scalars['ID']['input'];
}>;


export type BulkAllocationSuggestionActionsDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebom: { __typename?: 'Ebom', ebomParts: Array<{ __typename?: 'EbomPart', milliQuantity: number, stepAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number }>, stepAllocationSuggestions: Array<{ __typename?: 'EbomPartAllocationSuggestion', id: string, decision: EbomPartAllocationSuggestionDecision, milliQuantity: number }> }> } } };

export type BulkAllocationSuggestionActionsRejectMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkAllocationSuggestionActionsRejectMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', rejectEbomPartAllocationSuggestions: Array<string> } };

export type BulkAllocationSuggestionActionsAcceptMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkAllocationSuggestionActionsAcceptMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', acceptEbomPartAllocationSuggestions: Array<string> } };

export type BulkAllocationSuggestionActionsCreateMutationVariables = Exact<{
  ebomId: Scalars['ID']['input'];
}>;


export type BulkAllocationSuggestionActionsCreateMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', createEbomPartAllocationSuggestions: Array<{ __typename?: 'EbomPartAllocationSuggestion', id: string }> } };

export type EbomPartPickerDataQueryVariables = Exact<{
  query: EbomPartSearchQuery;
}>;


export type EbomPartPickerDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebomParts: Array<{ __typename?: 'EbomPart', id: string, articleNumber: string, revision: string, name?: string, articlePath: { __typename?: 'ArticlePath', articleNumbers: Array<string> }, article?: { __typename?: 'Article', id: string } }> } };

export type PartPickerDataQueryVariables = Exact<{
  searchString?: InputMaybe<Scalars['String']['input']>;
}>;


export type PartPickerDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', articles: Array<{ __typename?: 'Article', id: string, articleNumber: string, revision: string, name?: string }> } };

export type BopPickerDataQueryVariables = Exact<{
  productConfigurationId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type BopPickerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', productConfiguration: { __typename?: 'ProductConfiguration', bopsAtSite: Array<{ __typename?: 'BOP', id: string, version: number, versionStatus: VersionStatus }> } } };

export type GetUploadUrlForImageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  maxDimension: Scalars['Int']['input'];
}>;


export type GetUploadUrlForImageQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', upload: { __typename?: 'Upload', id: string, imageUrl: string } } };

export type ModulePickerDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
}>;


export type ModulePickerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', nodes: Array<{ __typename?: 'ModuleNode', module: { __typename?: 'Module', id: string, name: string, description?: string } }> } } };

export type GetUploadUrlForImagesQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  maxDimension: Scalars['Int']['input'];
}>;


export type GetUploadUrlForImagesQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', uploads: Array<{ __typename?: 'Upload', id: string, imageUrl: string }> } };

export type MultiUploadPickerDataQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MultiUploadPickerDataQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', uploads: Array<{ __typename?: 'Upload', id: string, name: string, contentType: string }> } };

export type OrganizationSlugDataQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  orgId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OrganizationSlugDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', isOrganizationSlugTaken: boolean } };

export type OrganizationUserPickerFindUserQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationUserPickerFindUserQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizationSearchUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }> } };

export type OrganizationUserPickerQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrganizationUserPickerQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizationUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }> } };

export type ProductConfigurationPickerDataQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type ProductConfigurationPickerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', product: { __typename?: 'Product', productConfigurations: Array<{ __typename?: 'ProductConfiguration', id: string, name: string }> } } };

export type ProductPickerDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductPickerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', products: Array<{ __typename?: 'Product', id: string, name: string }> } };

export type SitePickerDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SitePickerDataQuery = { __typename?: 'Query', site: { __typename?: 'SiteRoot', sites: Array<{ __typename?: 'Site', id: string, name: string, archived: boolean }> } };

export type StepOutputPickerDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
}>;


export type StepOutputPickerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', outputs: Array<{ __typename?: 'StepOutput', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, articleNumber: string, name?: string, revision: string, unit: ArticleUnit } }> } } };

export type StepPickerDataQueryVariables = Exact<{
  moduleId: Scalars['ID']['input'];
}>;


export type StepPickerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', module: { __typename?: 'Module', abbreviation: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, step: { __typename?: 'Step', id: string, name: string, durationInSeconds: number, instructionText?: string, stepType: { __typename?: 'StepType', id: string, name: string }, outputs: Array<{ __typename?: 'StepOutput', id: string }> } }> } } };

export type GetStepTypesForPickerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStepTypesForPickerQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', stepTypes: Array<{ __typename?: 'StepType', id: string, name: string, archived: boolean }> } };

export type ToolPickerDataQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ToolPickerDataQuery = { __typename?: 'Query', site: { __typename?: 'SiteRoot', site: { __typename?: 'Site', tools: Array<{ __typename?: 'Tool', id: string, name: string, description?: string, archived: boolean, imageUploads: Array<{ __typename?: 'Upload', imageUrl: string }> }> } } };

export type IsUserEmailTakenQueryVariables = Exact<{
  email: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type IsUserEmailTakenQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', isEmailTaken: boolean } };

export type CreateIssueDialogMutationVariables = Exact<{
  command: CreateIssue;
}>;


export type CreateIssueDialogMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', createIssue: { __typename?: 'Issue', id: string } } };

export type CreateIssueDialogLinkToStepMutationVariables = Exact<{
  command: LinkIssueToStep;
}>;


export type CreateIssueDialogLinkToStepMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToStep: { __typename?: 'StepIssueLink', id: string } } };

export type CreateIssueDialogLinkToModuleMutationVariables = Exact<{
  command: LinkIssueToModule;
}>;


export type CreateIssueDialogLinkToModuleMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToModule: { __typename?: 'ModuleIssueLink', id: string } } };

export type CreateIssueDialogLinkToBopMutationVariables = Exact<{
  command: LinkIssueToBop;
}>;


export type CreateIssueDialogLinkToBopMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToBOP: { __typename?: 'BOPIssueLink', id: string } } };

export type CreateIssueDialogLinkToSerialNumbersMutationVariables = Exact<{
  command: LinkIssueToSerialNumbers;
}>;


export type CreateIssueDialogLinkToSerialNumbersMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToSerialNumbers: Array<{ __typename?: 'SerialNumberIssueLink', id: string }> } };

export type CreateIssueDialogLinkToArticleMutationVariables = Exact<{
  command: LinkIssueToArticle;
}>;


export type CreateIssueDialogLinkToArticleMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToArticle: { __typename?: 'ArticleIssueLink', id: string } } };

export type CreateIssueLinkDialogBopMutationVariables = Exact<{
  command: LinkIssueToBop;
}>;


export type CreateIssueLinkDialogBopMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToBOP: { __typename?: 'BOPIssueLink', id: string } } };

export type CreateIssueLinkDialogModuleMutationVariables = Exact<{
  command: LinkIssueToModule;
}>;


export type CreateIssueLinkDialogModuleMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToModule: { __typename?: 'ModuleIssueLink', id: string } } };

export type CreateIssueLinkDialogStepMutationVariables = Exact<{
  command: LinkIssueToStep;
}>;


export type CreateIssueLinkDialogStepMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToStep: { __typename?: 'StepIssueLink', id: string } } };

export type CreateIssueLinkDialogSerialNumberMutationVariables = Exact<{
  command: LinkIssueToSerialNumber;
}>;


export type CreateIssueLinkDialogSerialNumberMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToSerialNumber: { __typename?: 'SerialNumberIssueLink', id: string } } };

export type CreateIssueLinkDialogArticleMutationVariables = Exact<{
  command: LinkIssueToArticle;
}>;


export type CreateIssueLinkDialogArticleMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', linkIssueToArticle: { __typename?: 'ArticleIssueLink', id: string } } };

export type IssueCommentListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IssueCommentListQuery = { __typename?: 'Query', issue: { __typename?: 'IssueRoot', issue: { __typename?: 'Issue', comments: Array<{ __typename?: 'IssueComment', id: string, createdAt: any, uploadIds: Array<string>, description: string, resolvedAt?: any, updatedAt: any, createdByUser: { __typename?: 'User', id: string, firstname: string, lastname: string } }> } } };

export type IssueCommentListCreateMutationVariables = Exact<{
  command: CreateIssueComment;
}>;


export type IssueCommentListCreateMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', createIssueComment: { __typename?: 'IssueComment', id: string } } };

export type IssueCommentListUpdateMutationVariables = Exact<{
  command: UpdateIssueComment;
}>;


export type IssueCommentListUpdateMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', updateIssueComment: { __typename?: 'IssueComment', id: string } } };

export type IssueCommentListDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IssueCommentListDeleteMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', deleteIssueComment: string } };

export type IssueCommentListResolveMutationVariables = Exact<{
  command: SetIssueResolved;
}>;


export type IssueCommentListResolveMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', setIssueCommentResolved: { __typename?: 'IssueComment', id: string } } };

export type IssueDialogDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IssueDialogDataQuery = { __typename?: 'Query', issue: { __typename?: 'IssueRoot', issue: { __typename?: 'Issue', id: string, createdAt: any, description: string, name: string, resolvedAt?: any, updatedAt: any, uploadIds: Array<string>, assignedToUserIds: Array<string>, createdByUser: { __typename?: 'User', id: string, firstname: string, lastname: string } } } };

export type IssueDialogUpdateMutationVariables = Exact<{
  command: UpdateIssue;
}>;


export type IssueDialogUpdateMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', updateIssue: { __typename?: 'Issue', id: string } } };

export type IssueDialogDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IssueDialogDeleteMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', deleteIssue: string } };

export type IssueLinkEditListDataQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type IssueLinkEditListDataQuery = { __typename?: 'Query', issue: { __typename?: 'IssueRoot', issue: { __typename?: 'Issue', id: string, links: Array<{ __typename?: 'ArticleIssueLink', id: string, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string } } | { __typename?: 'BOPIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } } | { __typename?: 'ModuleIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string } } | { __typename?: 'SerialNumberIssueLink', id: string, poNumber: string, serialNumber: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } } | { __typename?: 'StepIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } }> } } };

export type IssueLinkEditListDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IssueLinkEditListDeleteMutation = { __typename?: 'Mutation', issue: { __typename?: 'IssueMutationRoot', deleteIssueLink: string } };

export type IssuesPerDayGraphQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  till: Scalars['DateTime']['input'];
}>;


export type IssuesPerDayGraphQuery = { __typename?: 'Query', issue: { __typename?: 'IssueRoot', issuesPerDay: Array<{ __typename?: 'IssuesPerDay', day: any, created: number, resolved: number, open: number }> } };

type IssueLinkDisplayDetails_ArticleIssueLink_Fragment = { __typename?: 'ArticleIssueLink', id: string, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string } };

type IssueLinkDisplayDetails_BopIssueLink_Fragment = { __typename?: 'BOPIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } };

type IssueLinkDisplayDetails_ModuleIssueLink_Fragment = { __typename?: 'ModuleIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string } };

type IssueLinkDisplayDetails_SerialNumberIssueLink_Fragment = { __typename?: 'SerialNumberIssueLink', id: string, poNumber: string, serialNumber: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } };

type IssueLinkDisplayDetails_StepIssueLink_Fragment = { __typename?: 'StepIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } };

export type IssueLinkDisplayDetailsFragment = IssueLinkDisplayDetails_ArticleIssueLink_Fragment | IssueLinkDisplayDetails_BopIssueLink_Fragment | IssueLinkDisplayDetails_ModuleIssueLink_Fragment | IssueLinkDisplayDetails_SerialNumberIssueLink_Fragment | IssueLinkDisplayDetails_StepIssueLink_Fragment;

export type IssueLinkBopDetailsFragment = { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } };

export type IssueLinkModuleDetailsFragment = { __typename?: 'Module', id: string, name: string };

export type IssueLinkStepDetailsFragment = { __typename?: 'Step', id: string, name: string };

type AssociatedIssueTableIssueLink_ArticleIssueLink_Fragment = { __typename?: 'ArticleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } };

type AssociatedIssueTableIssueLink_BopIssueLink_Fragment = { __typename?: 'BOPIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } };

type AssociatedIssueTableIssueLink_ModuleIssueLink_Fragment = { __typename?: 'ModuleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } };

type AssociatedIssueTableIssueLink_SerialNumberIssueLink_Fragment = { __typename?: 'SerialNumberIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } };

type AssociatedIssueTableIssueLink_StepIssueLink_Fragment = { __typename?: 'StepIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } };

export type AssociatedIssueTableIssueLinkFragment = AssociatedIssueTableIssueLink_ArticleIssueLink_Fragment | AssociatedIssueTableIssueLink_BopIssueLink_Fragment | AssociatedIssueTableIssueLink_ModuleIssueLink_Fragment | AssociatedIssueTableIssueLink_SerialNumberIssueLink_Fragment | AssociatedIssueTableIssueLink_StepIssueLink_Fragment;

export type AccountMenuDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountMenuDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizations: Array<{ __typename?: 'OrganizationUserPermissions', organization: { __typename?: 'Organization', id: string, slug: string, name: string } }> } };

export type GetOrganizationInfoQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetOrganizationInfoQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizationBySlug?: { __typename?: 'Organization', id: string, name: string, slug: string } } };

export type UserInfoDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInfoDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', me?: { __typename?: 'CurrentUserAndPermissions', userPermissions: Array<PermissionUser>, orgPermissions: Array<PermissionOrganization>, organization?: { __typename?: 'Organization', id: string, name: string, slug: string }, user: { __typename?: 'User', id: string, firstname: string, lastname: string, email: string } } } };

export type DownloadMbomDialogDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
}>;


export type DownloadMbomDialogDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', nodes: Array<{ __typename?: 'ModuleNode', id: string, module: { __typename?: 'Module', id: string, name: string, abbreviation: string, description?: string } }> } } };

export type DuplicateModuleMutationVariables = Exact<{
  command: DuplicateModule;
}>;


export type DuplicateModuleMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', duplicateModule: { __typename?: 'Module', id: string } } };

export type OperatorBreadcrumbDataQueryVariables = Exact<{
  includeBop: Scalars['Boolean']['input'];
  bopId: Scalars['ID']['input'];
}>;


export type OperatorBreadcrumbDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', products: Array<{ __typename?: 'Product', id: string, name: string, productConfigurations: Array<{ __typename?: 'ProductConfiguration', id: string, name: string }> }>, bop?: { __typename?: 'BOP', version: number, versionStatus: VersionStatus, site: { __typename?: 'Site', name: string }, nodes: Array<{ __typename?: 'ModuleNode', module: { __typename?: 'Module', id: string, name: string } }> } } };

export type CurrentProductionBatchDataQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentProductionBatchDataQuery = { __typename?: 'Query', shopFloor: { __typename?: 'ShopFloorRoot', productionBatchesInProgressForCurrentUser: Array<{ __typename?: 'ProductionBatch', id: string, poNumber: string, serialNumbers: Array<string>, completed: boolean, assignedUser?: { __typename?: 'User', id: string }, module: { __typename?: 'Module', id: string }, currentStep?: { __typename?: 'Step', id: string } }> } };

export type CurrentProductionBatchUpdateMutationVariables = Exact<{
  command: UpdateProductionBatchCommand;
}>;


export type CurrentProductionBatchUpdateMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', updateProductionBatch: { __typename?: 'ProductionBatch', id: string, poNumber: string, serialNumbers: Array<string>, completed: boolean, assignedUser?: { __typename?: 'User', id: string }, module: { __typename?: 'Module', id: string }, currentStep?: { __typename?: 'Step', id: string } } } };

export type CompleteProductionBranchDataQueryVariables = Exact<{
  moduleId: Scalars['ID']['input'];
}>;


export type CompleteProductionBranchDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', module: { __typename?: 'Module', id: string, abbreviation: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, step: { __typename?: 'Step', id: string, name: string, checkConfigurations: Array<{ __typename?: 'CheckConfiguration', id: string, description: string, isRequired: boolean, unreleasedChecks: Array<{ __typename?: 'ConfirmCheck', id: string, poNumber: string, serialNumber: string, reportingUser: { __typename?: 'User', id: string } } | { __typename?: 'NumericCheck', id: string, poNumber: string, serialNumber: string, reportingUser: { __typename?: 'User', id: string } } | { __typename?: 'StringCheck', id: string, poNumber: string, serialNumber: string, reportingUser: { __typename?: 'User', id: string } }> }> } }> } } };

export type CreateProductionBatchMutationVariables = Exact<{
  command: CreateProductionBatchCommand;
}>;


export type CreateProductionBatchMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', createProductionBatch: { __typename?: 'ProductionBatch', id: string } } };

export type UserProductionBatchesDataQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserProductionBatchesDataQuery = { __typename?: 'Query', shopFloor: { __typename?: 'ShopFloorRoot', productionBatchesInProgressForUser: Array<{ __typename?: 'ProductionBatch', id: string, poNumber: string, serialNumbers: Array<string>, assignedUser?: { __typename?: 'User', id: string }, currentStep?: { __typename?: 'Step', id: string, name: string }, bop: { __typename?: 'BOP', id: string, version: number, site: { __typename?: 'Site', id: string, name: string }, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } } }, module: { __typename?: 'Module', id: string, name: string } }> } };

export type UserProductionBatchesTransferMutationVariables = Exact<{
  command: TransferProductionBatchCommand;
}>;


export type UserProductionBatchesTransferMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', transferProductionBatch: { __typename?: 'ProductionBatch', id: string } } };

export type UserProductionBatchesDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserProductionBatchesDeleteMutation = { __typename?: 'Mutation', shopFloor: { __typename?: 'ShopFloorMutationRoot', deleteProductionBatch: string } };

export type ViewProductionBatchDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ViewProductionBatchDataQuery = { __typename?: 'Query', shopFloor: { __typename?: 'ShopFloorRoot', productionBatch?: { __typename?: 'ProductionBatch', poNumber: string, serialNumbers: Array<string>, completed: boolean, assignedUser?: { __typename?: 'User', firstname: string, lastname: string }, module: { __typename?: 'Module', id: string, name: string }, bop: { __typename?: 'BOP', id: string, version: number, site: { __typename?: 'Site', id: string, name: string }, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } } } } } };

export type ViewProductionBatchSerialNumberDataQueryVariables = Exact<{
  poNumber: Scalars['String']['input'];
  serialNumber: Scalars['String']['input'];
}>;


export type ViewProductionBatchSerialNumberDataQuery = { __typename?: 'Query', shopFloor: { __typename?: 'ShopFloorRoot', checks: Array<{ __typename?: 'ConfirmCheck', id: string, createdAt: any, confirmed: boolean, reportingUser: { __typename?: 'User', firstname: string, lastname: string }, configuration: { __typename?: 'CheckConfiguration', description: string, id: string } } | { __typename?: 'NumericCheck', milliQuantity: number, id: string, createdAt: any, reportingUser: { __typename?: 'User', firstname: string, lastname: string }, configuration: { __typename?: 'CheckConfiguration', description: string, id: string } } | { __typename?: 'StringCheck', text: string, id: string, createdAt: any, reportingUser: { __typename?: 'User', firstname: string, lastname: string }, configuration: { __typename?: 'CheckConfiguration', description: string, id: string } }> }, issue: { __typename?: 'IssueRoot', issues: Array<{ __typename?: 'Issue', id: string, name: string, createdAt: any, createdByUser: { __typename?: 'User', firstname: string, lastname: string } }> } };

export type CreateStepAndAddNodeToModuleGraphMutationVariables = Exact<{
  step: CreateStep;
  node: AddTreeGraphNode;
}>;


export type CreateStepAndAddNodeToModuleGraphMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', addNodeToModuleGraph: boolean, createStep: { __typename?: 'Step', id: string } } };

export type DuplicateStepMutationVariables = Exact<{
  command: DuplicateStep;
}>;


export type DuplicateStepMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', duplicateStep: { __typename?: 'Step', id: string } } };

export type StepInputsSectionDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
}>;


export type StepInputsSectionDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', inputs: Array<{ __typename?: 'StepInput', id: string, milliQuantity: number, output: { __typename?: 'StepOutput', id: string, milliQuantity: number, step: { __typename?: 'Step', id: string, name: string }, module: { __typename?: 'Module', id: string, name: string }, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string, name?: string, unit: ArticleUnit } } }> } } };

export type CreateStepInputMutationVariables = Exact<{
  command: CreateStepInput;
}>;


export type CreateStepInputMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createStepInput: { __typename?: 'StepInput', id: string } } };

export type UpdateStepInputMutationVariables = Exact<{
  command: UpdateStepInput;
}>;


export type UpdateStepInputMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateStepInput: { __typename?: 'StepInput', id: string } } };

export type DeleteStepInputMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteStepInputMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteStepInput: string } };

export type StepOutputsSectionDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
}>;


export type StepOutputsSectionDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', outputs: Array<{ __typename?: 'StepOutput', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, name?: string, articleNumber: string, revision: string, unit: ArticleUnit } }> } } };

export type CreateStepOutputMutationVariables = Exact<{
  command: CreateStepOutput;
}>;


export type CreateStepOutputMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createStepOutput: { __typename?: 'StepOutput', id: string } } };

export type UpdateStepOutputMutationVariables = Exact<{
  command: UpdateStepOutput;
}>;


export type UpdateStepOutputMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateStepOutput: { __typename?: 'StepOutput', id: string } } };

export type DeleteStepOutputMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteStepOutputMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteStepOutput: string } };

export type StepProposalConverterStepMutationVariables = Exact<{
  command: CreateStep;
  node: AddTreeGraphNode;
}>;


export type StepProposalConverterStepMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', addNodeToModuleGraph: boolean, createStep: { __typename?: 'Step', id: string } } };

export type StepProposalConverterVideosMutationVariables = Exact<{
  commands: Array<CreateVideoStepUpload> | CreateVideoStepUpload;
}>;


export type StepProposalConverterVideosMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createVideoStepUploads: Array<{ __typename?: 'VideoStepUpload', id: string }> } };

export type StepProposalsFromMediaMimeTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type StepProposalsFromMediaMimeTypesQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', createStepProposalsFromMediaSupportedMimeTypes: Array<string> } };

export type StepProposalsFromMediaMutationVariables = Exact<{
  command: CreateStepProposalsFromMedia;
}>;


export type StepProposalsFromMediaMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createStepProposalsFromMedia: { __typename?: 'StepProposalResult', errors: Array<string>, proposals: Array<{ __typename?: 'StepProposal', id: string, name: string, instructionText?: string, durationInSeconds: number, videoUploadProposals: Array<{ __typename?: 'VideoStepUploadProposal', id: string, fragmentStartInMillis?: number, fragmentEndInMillis?: number, upload: { __typename?: 'Upload', id: string, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension', url: string } } }> }> } } };

export type StepProposalsFromPdfAnalysisQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StepProposalsFromPdfAnalysisQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', upload: { __typename?: 'Upload', extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension' } | { __typename?: 'PdfExtension', analysis: { __typename?: 'PdfExtensionAnalysis', numberOfPages: number, numberOfImages: number } } | { __typename?: 'VideoExtension' } } } };

export type StepProposalsFromPdfMutationVariables = Exact<{
  command: CreateStepProposalsFromPdf;
}>;


export type StepProposalsFromPdfMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createStepProposalsFromPDF: { __typename?: 'StepProposalResult', errors: Array<string>, proposals: Array<{ __typename?: 'StepProposal', id: string, name: string, instructionText?: string, durationInSeconds: number, videoUploadProposals: Array<{ __typename?: 'VideoStepUploadProposal', id: string, fragmentStartInMillis?: number, fragmentEndInMillis?: number, upload: { __typename?: 'Upload', id: string, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension', url: string } } }> }> } } };

export type StepToolbarDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StepToolbarDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', id: string, name: string } } };

export type DeleteStepMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteStepMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteStep?: string } };

export type StepTreeDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
  includeIssues: Scalars['Boolean']['input'];
}>;


export type StepTreeDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', versionStatus: VersionStatus }, module: { __typename?: 'Module', id: string, abbreviation: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, step: { __typename?: 'Step', id: string, name: string, durationInSeconds: number, stepType: { __typename?: 'StepType', id: string, name: string }, issueLinks?: Array<{ __typename?: 'ArticleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } } | { __typename?: 'BOPIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } } | { __typename?: 'ModuleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } } | { __typename?: 'SerialNumberIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } } | { __typename?: 'StepIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } }> } }> } } };

export type SetGraphForModuleMutationVariables = Exact<{
  graph: SetTreeGraph;
}>;


export type SetGraphForModuleMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', setModuleGraph: boolean } };

export type UpdateStepDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeIssues: Scalars['Boolean']['input'];
}>;


export type UpdateStepDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', id: string, durationInSeconds: number, instructionText?: string, name: string, toolIds: Array<string>, stepType: { __typename?: 'StepType', id: string, name: string }, tools: Array<{ __typename?: 'Tool', id: string, name: string, imageUploads: Array<{ __typename?: 'Upload', id: string, imageUrl: string }> }>, issueLinks?: Array<{ __typename?: 'ArticleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } } | { __typename?: 'BOPIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } } | { __typename?: 'ModuleIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } } | { __typename?: 'SerialNumberIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } } | { __typename?: 'StepIssueLink', id: string, issue: { __typename?: 'Issue', id: string, name: string, createdAt: any, resolvedAt?: any } }> } } };

export type UpdateStepMutationVariables = Exact<{
  step: UpdateStep;
}>;


export type UpdateStepMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateStep: { __typename?: 'Step', id: string } } };

export type ViewStepDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  imageOptions: ImageOptions;
}>;


export type ViewStepDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', id: string, durationInSeconds: number, instructionText?: string, name: string, toolIds: Array<string>, stepType: { __typename?: 'StepType', id: string, name: string }, tools: Array<{ __typename?: 'Tool', id: string, name: string, description?: string, imageUploads: Array<{ __typename?: 'Upload', id: string, imageUrl: string }> }>, articleAllocations: Array<{ __typename?: 'EbomPartAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, type: ArticleType, name?: string, unit: ArticleUnit, revision: string, articleNumber: string } } | { __typename?: 'ManualArticleAllocation', id: string, milliQuantity: number, article: { __typename?: 'Article', id: string, type: ArticleType, name?: string, unit: ArticleUnit, revision: string, articleNumber: string } }>, inputs: Array<{ __typename?: 'StepInput', id: string, milliQuantity: number, output: { __typename?: 'StepOutput', id: string, milliQuantity: number, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string }, article: { __typename?: 'Article', id: string, name?: string, articleNumber: string, revision: string, unit: ArticleUnit } } }> } } };

export type StepProposalResultDetailsFragment = { __typename?: 'StepProposalResult', errors: Array<string>, proposals: Array<{ __typename?: 'StepProposal', id: string, name: string, instructionText?: string, durationInSeconds: number, videoUploadProposals: Array<{ __typename?: 'VideoStepUploadProposal', id: string, fragmentStartInMillis?: number, fragmentEndInMillis?: number, upload: { __typename?: 'Upload', id: string, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension', url: string } } }> }> };

export type CreateImageStepUploadMutationVariables = Exact<{
  command: CreateImageStepUpload;
}>;


export type CreateImageStepUploadMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createImageStepUpload: { __typename?: 'ImageStepUpload', id: string } } };

export type CreateVideoStepUploadMutationVariables = Exact<{
  command: CreateVideoStepUpload;
}>;


export type CreateVideoStepUploadMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createVideoStepUpload: { __typename?: 'VideoStepUpload', id: string } } };

export type FormImageStepUploadDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  options: ImageOptions;
}>;


export type FormImageStepUploadDataQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', upload: { __typename?: 'Upload', extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension', url: string } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension' } } } };

export type FormVideoStepUploadDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FormVideoStepUploadDataQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', upload: { __typename?: 'Upload', extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension' } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension', url: string } } } };

export type StepUploadListDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
  imageOptions: ImageOptions;
}>;


export type StepUploadListDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', uploads: Array<{ __typename?: 'ImageStepUpload', id: string, upload: { __typename?: 'Upload', name: string, contentType: string, extension: { __typename: 'CsvExtension' } | { __typename: 'GenericExtension' } | { __typename: 'ImageExtension', url: string } | { __typename: 'PdfExtension' } | { __typename: 'VideoExtension' } } } | { __typename?: 'VideoStepUpload', id: string, upload: { __typename?: 'Upload', name: string, contentType: string, extension: { __typename: 'CsvExtension' } | { __typename: 'GenericExtension' } | { __typename: 'ImageExtension' } | { __typename: 'PdfExtension' } | { __typename: 'VideoExtension' } } }> } } };

export type StepUploadListDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StepUploadListDeleteMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteStepUpload: string } };

export type StepUploadListMoveMutationVariables = Exact<{
  stepId: Scalars['ID']['input'];
  command: Move;
}>;


export type StepUploadListMoveMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', moveStepUpload: boolean } };

export type StepUploadViewerDataQueryVariables = Exact<{
  stepId: Scalars['ID']['input'];
  imageOptions: ImageOptions;
}>;


export type StepUploadViewerDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', step: { __typename?: 'Step', uploads: Array<{ __typename?: 'ImageStepUpload', id: string, caption?: string, upload: { __typename?: 'Upload', id: string, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension', url: string } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension', url: string } } } | { __typename?: 'VideoStepUpload', id: string, caption?: string, fragmentStartInMillis?: number, fragmentEndInMillis?: number, fragmentLoop?: boolean, upload: { __typename?: 'Upload', id: string, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension', url: string } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension', url: string } } }> } } };

export type UpdateImageStepUploadDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UpdateImageStepUploadDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', imageStepUpload: { __typename?: 'ImageStepUpload', id: string, caption?: string, upload: { __typename?: 'Upload', id: string } } } };

export type UpdateImageStepUploadMutationVariables = Exact<{
  command: UpdateImageStepUpload;
}>;


export type UpdateImageStepUploadMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateImageStepUpload: { __typename?: 'ImageStepUpload', id: string } } };

export type UpdateVideoStepUploadDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UpdateVideoStepUploadDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', videoStepUpload: { __typename?: 'VideoStepUpload', id: string, caption?: string, fragmentStartInMillis?: number, fragmentEndInMillis?: number, fragmentLoop?: boolean, upload: { __typename?: 'Upload', id: string } } } };

export type UpdateVideoStepUploadMutationVariables = Exact<{
  command: UpdateVideoStepUpload;
}>;


export type UpdateVideoStepUploadMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateVideoStepUpload: { __typename?: 'VideoStepUpload', id: string } } };

export type ImagesViewerDataQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
}>;


export type ImagesViewerDataQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', uploads: Array<{ __typename?: 'Upload', id: string, name: string, imageUrl: string }> } };

export type UploadListDataQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UploadListDataQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', uploads: Array<{ __typename?: 'Upload', id: string, createdAt: any, name: string, contentType: string }> } };

export type UploadListUrlQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UploadListUrlQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', upload: { __typename?: 'Upload', id: string, url: string, name: string } } };

export type UploadPickerDataQueryVariables = Exact<{
  query: UploadQuery;
  imageOptions: ImageOptions;
}>;


export type UploadPickerDataQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', search: Array<{ __typename?: 'Upload', id: string, contentType: string, name: string, createdAt: any, extension: { __typename?: 'CsvExtension' } | { __typename?: 'GenericExtension' } | { __typename?: 'ImageExtension', url: string } | { __typename?: 'PdfExtension' } | { __typename?: 'VideoExtension' } }> } };

export type UploadPickerSelectedUploadsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UploadPickerSelectedUploadsQuery = { __typename?: 'Query', upload: { __typename?: 'UploadRoot', uploads: Array<{ __typename?: 'Upload', id: string, contentType: string, name: string }> } };

export type AgreeToTermsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AgreeToTermsDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', hasAgreedToTerms: boolean } };

export type AgreeToTermsAgreementMutationVariables = Exact<{
  logEntry: Scalars['String']['input'];
}>;


export type AgreeToTermsAgreementMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', agreeToTerms: boolean } };

export type OrganizationUserListDataQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type OrganizationUserListDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizationUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }> } };

export type UserOrganizationPermissionsDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserOrganizationPermissionsDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizationPermissions: Array<PermissionOrganization>, organizationUser: { __typename?: 'User', id: string, firstname: string, lastname: string } } };

export type UserOrganizationPermissionsSetMutationVariables = Exact<{
  command: SetOrganizationPermissions;
}>;


export type UserOrganizationPermissionsSetMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', setOrganizationPermissions: Array<PermissionOrganization> } };

export type UserPlatformPermissionsDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserPlatformPermissionsDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', adminUserPermissions: Array<PermissionUser>, adminOrganizations: Array<{ __typename?: 'Organization', id: string, name: string }>, adminUser: { __typename?: 'User', firstname: string, lastname: string }, adminOrganizationPermissions: Array<{ __typename?: 'OrganizationUserPermissions', permissions: Array<PermissionOrganization>, organization: { __typename?: 'Organization', id: string, name: string } }> } };

export type AdminSetUserPermissionsMutationVariables = Exact<{
  command: SetUserPermissions;
}>;


export type AdminSetUserPermissionsMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminSetUserPermissions: Array<PermissionUser> } };

export type AdminSetOrgPermissionsMutationVariables = Exact<{
  command: SetOrganizationPermissions;
}>;


export type AdminSetOrgPermissionsMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminSetOrganizationPermissions: Array<PermissionOrganization> } };

export type DeleteOrgUserPermissionsMutationVariables = Exact<{
  command: DeleteOrganizationPermissions;
}>;


export type DeleteOrgUserPermissionsMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminDeleteOrganizationPermissions: boolean } };

export type UseAuthorizationDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UseAuthorizationDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', orgPermissionsHierarchy: Array<{ __typename?: 'OrgReachablePermission', permission: PermissionOrganization, reachable: Array<PermissionOrganization> }>, me?: { __typename?: 'CurrentUserAndPermissions', userPermissions: Array<PermissionUser>, orgPermissions: Array<PermissionOrganization> } } };

export type FinalizeMultipartUploadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FinalizeMultipartUploadMutation = { __typename?: 'Mutation', upload: { __typename?: 'UploadMutationRoot', finalizeMultipartUpload: { __typename?: 'Upload', id: string, name: string, contentType: string, createdAt: any } } };

export type CreateMultipartUploadMutationVariables = Exact<{
  command: CreateMultipartUpload;
}>;


export type CreateMultipartUploadMutation = { __typename?: 'Mutation', upload: { __typename?: 'UploadMutationRoot', createMultipartUpload: string } };

export type HomeViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeViewDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizations: Array<{ __typename?: 'OrganizationUserPermissions', organization: { __typename?: 'Organization', id: string, name: string, slug: string } }> } };

export type AdminOrganizationViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminOrganizationViewDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', adminOrganizations: Array<{ __typename?: 'Organization', id: string, name: string, slug: string }> } };

export type AdminOrganizationViewCreateMutationVariables = Exact<{
  command: CreateOrganization;
}>;


export type AdminOrganizationViewCreateMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminCreateOrganization: { __typename?: 'Organization', id: string } } };

export type AdminOrganizationViewUpdateMutationVariables = Exact<{
  command: UpdateOrganization;
}>;


export type AdminOrganizationViewUpdateMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminUpdateOrganization: { __typename?: 'Organization', id: string } } };

export type AdminOrganizationViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AdminOrganizationViewDeleteMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminDeleteOrganization: string } };

export type AdminUserViewDataQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminUserViewDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', adminSearchUsers: Array<{ __typename?: 'User', id: string, email: string, firstname: string, lastname: string }> } };

export type AdminUserViewCreateMutationVariables = Exact<{
  command: CreateUser;
}>;


export type AdminUserViewCreateMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminCreateUser: { __typename?: 'User', id: string } } };

export type AdminUserViewUpdateMutationVariables = Exact<{
  command: UpdateUser;
}>;


export type AdminUserViewUpdateMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', adminUpdateUser: { __typename?: 'User', id: string } } };

export type ArticleViewDataQueryVariables = Exact<{
  query: ArticleSearchQuery;
}>;


export type ArticleViewDataQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', articles: Array<{ __typename?: 'Article', id: string, type: ArticleType, articleNumber: string, revision: string, unit: ArticleUnit, name?: string, released: boolean }> } };

export type ArticleViewUpdateArticleMutationVariables = Exact<{
  command: UpdateArticle;
}>;


export type ArticleViewUpdateArticleMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', updateArticle: { __typename?: 'Article', id: string } } };

export type ArticleViewDeleteArticleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArticleViewDeleteArticleMutation = { __typename?: 'Mutation', article: { __typename?: 'ArticleMutationRoot', deleteArticle: string } };

export type BopProcessViewDataQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  productConfigId: Scalars['ID']['input'];
  bopId: Scalars['ID']['input'];
}>;


export type BopProcessViewDataQuery = { __typename?: 'Query', site: { __typename?: 'SiteRoot', site: { __typename?: 'Site', id: string, abbreviation: string } }, product: { __typename?: 'ProductRoot', product: { __typename?: 'Product', id: string, abbreviation: string }, productConfiguration: { __typename?: 'ProductConfiguration', id: string, abbreviation: string }, bop: { __typename?: 'BOP', id: string, versionStatus: VersionStatus, nodes: Array<{ __typename?: 'ModuleNode', id: string, parentIds: Array<string>, module: { __typename?: 'Module', id: string, name: string, abbreviation: string, description?: string, inputs: Array<{ __typename?: 'StepInput', id: string, milliQuantity: number, module: { __typename?: 'Module', id: string }, output: { __typename?: 'StepOutput', id: string, module: { __typename?: 'Module', id: string }, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string, unit: ArticleUnit } } }> } }> } } };

export type SetGraphMutationVariables = Exact<{
  graph: SetDagGraph;
}>;


export type SetGraphMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', setBillOfProcessGraph: boolean } };

export type CreateModuleMutationVariables = Exact<{
  module: CreateModule;
  graph: SetDagGraph;
}>;


export type CreateModuleMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', setBillOfProcessGraph: boolean, createModule: { __typename?: 'Module', id: string } } };

export type BopProcessViewUpdateMutationVariables = Exact<{
  module: UpdateModule;
}>;


export type BopProcessViewUpdateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateModule: { __typename?: 'Module', id: string } } };

export type DeleteModuleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteModuleMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteModule?: string } };

export type BopViewDataQueryVariables = Exact<{
  configId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type BopViewDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', productConfiguration: { __typename?: 'ProductConfiguration', bopsAtSite: Array<{ __typename?: 'BOP', id: string, version: number, versionStatus: VersionStatus }> } } };

export type BopViewCreateMutationVariables = Exact<{
  configId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type BopViewCreateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', draftBOP: { __typename?: 'BOP', id: string } } };

export type BopViewDuplicateMutationVariables = Exact<{
  command: DraftBopByDuplicating;
}>;


export type BopViewDuplicateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', draftBOPByDuplicating: { __typename?: 'BOP', id: string } } };

export type BopViewDeleteMutationVariables = Exact<{
  configId: Scalars['ID']['input'];
  siteId: Scalars['ID']['input'];
}>;


export type BopViewDeleteMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteLatestUnreleasedBOPVersion?: string } };

export type GetEbomQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEbomQuery = { __typename?: 'Query', article: { __typename?: 'ArticleRoot', ebom: { __typename?: 'Ebom', id: string, name: string, sourceId: string, sourceType: EbomSourceType } } };

export type IssueViewDataQueryVariables = Exact<{
  query: IssueSearchQuery;
}>;


export type IssueViewDataQuery = { __typename?: 'Query', issue: { __typename?: 'IssueRoot', issues: Array<{ __typename?: 'Issue', id: string, name: string, createdAt: any, updatedAt: any, resolvedAt?: any, assignedToUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string }>, links: Array<{ __typename?: 'ArticleIssueLink', id: string, article: { __typename?: 'Article', id: string, articleNumber: string, revision: string } } | { __typename?: 'BOPIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } } | { __typename?: 'ModuleIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string } } | { __typename?: 'SerialNumberIssueLink', id: string, poNumber: string, serialNumber: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } } | { __typename?: 'StepIssueLink', id: string, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } }, module: { __typename?: 'Module', id: string, name: string }, step: { __typename?: 'Step', id: string, name: string } }> }> } };

export type ModuleViewDataQueryVariables = Exact<{
  bopId: Scalars['ID']['input'];
  moduleId: Scalars['ID']['input'];
}>;


export type ModuleViewDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', bop: { __typename?: 'BOP', id: string, versionStatus: VersionStatus }, module: { __typename?: 'Module', id: string, name: string, abbreviation: string } } };

export type OrgHomeDataQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgHomeDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', me?: { __typename?: 'CurrentUserAndPermissions', organization?: { __typename?: 'Organization', id: string, name: string } } } };

export type ProductConfigurationViewDataQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type ProductConfigurationViewDataQuery = { __typename?: 'Query', site: { __typename?: 'SiteRoot', sites: Array<{ __typename?: 'Site', id: string, name: string }> }, product: { __typename?: 'ProductRoot', product: { __typename?: 'Product', productConfigurations: Array<{ __typename?: 'ProductConfiguration', id: string, name: string, abbreviation: string, description?: string, imageUploadId?: string, imageUpload?: { __typename?: 'Upload', id: string, imageUrl: string }, bops: Array<{ __typename?: 'BOP', id: string, version: number, versionStatus: VersionStatus, site: { __typename?: 'Site', id: string, name: string } }> }> } } };

export type ProductConfigurationViewCreateMutationVariables = Exact<{
  command: CreateProductConfiguration;
}>;


export type ProductConfigurationViewCreateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createProductConfiguration: { __typename?: 'ProductConfiguration', id: string } } };

export type ProductConfigurationViewUpdateMutationVariables = Exact<{
  command: UpdateProductConfiguration;
}>;


export type ProductConfigurationViewUpdateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateProductConfiguration: { __typename?: 'ProductConfiguration', id: string } } };

export type ProductConfigurationViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductConfigurationViewDeleteMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteProductConfiguration: string } };

export type ProductViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductViewDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', products: Array<{ __typename?: 'Product', id: string, name: string, abbreviation: string, description?: string, imageUploadId?: string, imageUpload?: { __typename?: 'Upload', id: string, imageUrl: string } }> } };

export type ProductViewCreateMutationVariables = Exact<{
  command: CreateProduct;
}>;


export type ProductViewCreateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createProduct: { __typename?: 'Product', id: string } } };

export type ProductViewUpdateMutationVariables = Exact<{
  command: UpdateProduct;
}>;


export type ProductViewUpdateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateProduct: { __typename?: 'Product', id: string } } };

export type ProductViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProductViewDeleteMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteProduct: string } };

export type ProductionBatchViewDataQueryVariables = Exact<{
  query: ProductionBatchQuery;
}>;


export type ProductionBatchViewDataQuery = { __typename?: 'Query', shopFloor: { __typename?: 'ShopFloorRoot', productionBatches: { __typename?: 'ProductionBatchPage', page: number, itemsPerPage: number, totalItems: number, totalPages: number, data: Array<{ __typename?: 'ProductionBatch', id: string, poNumber: string, serialNumbers: Array<string>, completed: boolean, module: { __typename?: 'Module', id: string, name: string }, bop: { __typename?: 'BOP', id: string, version: number, productConfiguration: { __typename?: 'ProductConfiguration', id: string, name: string, product: { __typename?: 'Product', id: string, name: string } }, site: { __typename?: 'Site', id: string, name: string } } }> } } };

export type SitesViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SitesViewDataQuery = { __typename?: 'Query', site: { __typename?: 'SiteRoot', sites: Array<{ __typename?: 'Site', id: string, name: string, abbreviation: string, archived: boolean }> } };

export type SiteViewCreateMutationVariables = Exact<{
  command: CreateSite;
}>;


export type SiteViewCreateMutation = { __typename?: 'Mutation', site: { __typename?: 'SiteMutationRoot', createSite: { __typename?: 'Site', id: string } } };

export type SiteViewUpdateMutationVariables = Exact<{
  command: UpdateSite;
}>;


export type SiteViewUpdateMutation = { __typename?: 'Mutation', site: { __typename?: 'SiteMutationRoot', updateSite: { __typename?: 'Site', id: string } } };

export type SiteViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SiteViewDeleteMutation = { __typename?: 'Mutation', site: { __typename?: 'SiteMutationRoot', deleteSite: string } };

export type StepTypeViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type StepTypeViewDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', stepTypes: Array<{ __typename?: 'StepType', id: string, name: string, archived: boolean, released: boolean }> } };

export type StepTypeViewCreateMutationVariables = Exact<{
  command: CreateStepType;
}>;


export type StepTypeViewCreateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', createStepType: { __typename?: 'StepType', id: string } } };

export type StepTypeViewUpdateMutationVariables = Exact<{
  command: UpdateStepType;
}>;


export type StepTypeViewUpdateMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', updateStepType: { __typename?: 'StepType', id: string } } };

export type StepTypeViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StepTypeViewDeleteMutation = { __typename?: 'Mutation', product: { __typename?: 'ProductMutationRoot', deleteStepType: string } };

export type ToolsViewDataQueryVariables = Exact<{
  siteId: Scalars['ID']['input'];
}>;


export type ToolsViewDataQuery = { __typename?: 'Query', site: { __typename?: 'SiteRoot', site: { __typename?: 'Site', tools: Array<{ __typename?: 'Tool', id: string, name: string, description?: string, archived: boolean, released: boolean, imageUploads: Array<{ __typename?: 'Upload', id: string }> }> } } };

export type ToolsViewCreateMutationVariables = Exact<{
  command: CreateTool;
}>;


export type ToolsViewCreateMutation = { __typename?: 'Mutation', site: { __typename?: 'SiteMutationRoot', createTool: { __typename?: 'Tool', id: string } } };

export type ToolsViewUpdateMutationVariables = Exact<{
  command: UpdateTool;
}>;


export type ToolsViewUpdateMutation = { __typename?: 'Mutation', site: { __typename?: 'SiteMutationRoot', updateTool: { __typename?: 'Tool', id: string } } };

export type ToolsViewDeleteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ToolsViewDeleteMutation = { __typename?: 'Mutation', site: { __typename?: 'SiteMutationRoot', deleteTool: string } };

export type OrgUserViewDataQueryVariables = Exact<{
  contains?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrgUserViewDataQuery = { __typename?: 'Query', account: { __typename?: 'AccountRoot', organizationSearchUsers: Array<{ __typename?: 'User', id: string, email: string, firstname: string, lastname: string }> } };

export type OrgUserViewCreateMutationVariables = Exact<{
  userCommand: CreateUser;
  permissions: Array<PermissionOrganization> | PermissionOrganization;
}>;


export type OrgUserViewCreateMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', inviteUserToOrganization: boolean } };

export type UserOrganizationPermissionsDeleteMutationVariables = Exact<{
  command: DeleteOrganizationPermissions;
}>;


export type UserOrganizationPermissionsDeleteMutation = { __typename?: 'Mutation', account: { __typename?: 'AccountMutationRoot', deleteOrganizationPermissions: boolean } };

export type OperatorViewDataQueryVariables = Exact<{ [key: string]: never; }>;


export type OperatorViewDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', products: Array<{ __typename?: 'Product', id: string, name: string, abbreviation: string, description?: string, imageUploadId?: string, imageUpload?: { __typename?: 'Upload', id: string, imageUrl: string } }> } };

export type OperatorStepTreeDataQueryVariables = Exact<{
  moduleId: Scalars['ID']['input'];
}>;


export type OperatorStepTreeDataQuery = { __typename?: 'Query', product: { __typename?: 'ProductRoot', module: { __typename?: 'Module', id: string, abbreviation: string, nodes: Array<{ __typename?: 'StepNode', id: string, parentId?: string, step: { __typename?: 'Step', id: string, name: string, durationInSeconds: number, stepType: { __typename?: 'StepType', id: string, name: string } } }> } } };

export type OperatorProductConfigurationViewDataQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type OperatorProductConfigurationViewDataQuery = { __typename?: 'Query', site: { __typename?: 'SiteRoot', sites: Array<{ __typename?: 'Site', id: string, name: string }> }, product: { __typename?: 'ProductRoot', product: { __typename?: 'Product', productConfigurations: Array<{ __typename?: 'ProductConfiguration', id: string, name: string, abbreviation: string, description?: string, imageUploadId?: string, imageUpload?: { __typename?: 'Upload', id: string, imageUrl: string }, bops: Array<{ __typename?: 'BOP', id: string, version: number, versionStatus: VersionStatus, site: { __typename?: 'Site', id: string, name: string }, nodes: Array<{ __typename?: 'ModuleNode', module: { __typename?: 'Module', id: string, name: string, description?: string, abbreviation: string } }> }> }> } } };
